// This file was autogenerated by some hot garbage in the `uniffi-bindgen-react-native` crate.
// Trust me, you don't want to mess with it!
import {
  type FfiConverter,
  type UniffiByteArray,
  type UniffiHandle,
  type UniffiObjectFactory,
  type UniffiReferenceHolder,
  type UniffiRustArcPtr,
  type UniffiRustCallStatus,
  type UnsafeMutableRawPointer,
  AbstractFfiConverterByteArray,
  FfiConverterArray,
  FfiConverterArrayBuffer,
  FfiConverterBool,
  FfiConverterInt32,
  FfiConverterObject,
  FfiConverterObjectWithCallbacks,
  FfiConverterOptional,
  FfiConverterUInt32,
  FfiConverterUInt64,
  RustBuffer,
  UniffiAbstractObject,
  UniffiEnum,
  UniffiError,
  UniffiInternalError,
  UniffiResult,
  UniffiRustCaller,
  destructorGuardSymbol,
  pointerLiteralSymbol,
  uniffiCreateFfiConverterString,
  uniffiCreateRecord,
  uniffiTraitInterfaceCallWithError,
  uniffiTypeNameSymbol,
  variantOrdinalSymbol,
} from 'uniffi-bindgen-react-native';

import * as wasmBundle from './wasm-bindgen/index.js';

// Get converters from the other files, if any.
const nativeModule = () => wasmBundle;
const uniffiCaller = new UniffiRustCaller(() => new wasmBundle.RustCallStatus());

const uniffiIsDebug =
  // @ts-ignore -- The process global might not be defined
  typeof process !== 'object' ||
  // @ts-ignore -- The process global might not be defined
  process?.env?.NODE_ENV !== 'production' ||
  false;
// Public interface members begin here.

/**
 * Create a client config with an in-memory group state storage.
 */
export function clientConfigDefault(): ClientConfig {
  return FfiConverterTypeClientConfig.lift(
    uniffiCaller.rustCall(
      /*caller:*/ (callStatus) => {
        return nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_func_client_config_default(callStatus);
      },
      /*liftString:*/ FfiConverterString.lift
    )
  );
}
/**
 * Generate a MLS signature keypair.
 *
 * This will use the default RustCrypto provider.
 *
 * See [`mls_rs::CipherSuiteProvider::signature_key_generate`]
 * for details.
 */
export function generateSignatureKeypair(cipherSuite: CipherSuite): SignatureKeypair /*throws*/ {
  return FfiConverterTypeSignatureKeypair.lift(
    uniffiCaller.rustCallWithError(
      /*liftError:*/ FfiConverterTypeError.lift.bind(FfiConverterTypeError),
      /*caller:*/ (callStatus) => {
        return nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_func_generate_signature_keypair(
          FfiConverterTypeCipherSuite.lower(cipherSuite),
          callStatus
        );
      },
      /*liftString:*/ FfiConverterString.lift
    )
  );
}
/**
 * Parse MLS-encoded bytes into a message.
 */
export function messageFromBytes(data: ArrayBuffer): MessageInterface /*throws*/ {
  return FfiConverterTypeMessage.lift(
    uniffiCaller.rustCallWithError(
      /*liftError:*/ FfiConverterTypeError.lift.bind(FfiConverterTypeError),
      /*caller:*/ (callStatus) => {
        return nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_func_message_from_bytes(
          FfiConverterArrayBuffer.lower(data),
          callStatus
        );
      },
      /*liftString:*/ FfiConverterString.lift
    )
  );
}
/**
 * Serialize a message to MLS-encoded bytes.
 */
export function messageToBytes(msg: MessageInterface): ArrayBuffer /*throws*/ {
  return FfiConverterArrayBuffer.lift(
    uniffiCaller.rustCallWithError(
      /*liftError:*/ FfiConverterTypeError.lift.bind(FfiConverterTypeError),
      /*caller:*/ (callStatus) => {
        return nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_func_message_to_bytes(
          FfiConverterTypeMessage.lower(msg),
          callStatus
        );
      },
      /*liftString:*/ FfiConverterString.lift
    )
  );
}

/**
 * Client configuration using callback-based storage.
 *
 * Group state is provided via the `group_state_storage` callback.
 * Key packages are provided via the `key_package_storage` callback.
 */
export type ClientConfig = {
  groupStateStorage: GroupStateStorage;
  keyPackageStorage: KeyPackageStorage;
  /**
   * Use the ratchet tree extension. If this is false, then you
   * must supply `ratchet_tree` out of band to clients.
   */
  useRatchetTreeExtension: boolean;
};

/**
 * Generated factory for {@link ClientConfig} record objects.
 */
export const ClientConfig = (() => {
  const defaults = () => ({});
  const create = (() => {
    return uniffiCreateRecord<ClientConfig, ReturnType<typeof defaults>>(defaults);
  })();
  return Object.freeze({
    /**
     * Create a frozen instance of {@link ClientConfig}, with defaults specified
     * in Rust, in the {@link mls_rs_uniffi} crate.
     */
    create,

    /**
     * Create a frozen instance of {@link ClientConfig}, with defaults specified
     * in Rust, in the {@link mls_rs_uniffi} crate.
     */
    new: create,

    /**
     * Defaults specified in the {@link mls_rs_uniffi} crate.
     */
    defaults: () => Object.freeze(defaults()) as Partial<ClientConfig>,
  });
})();

const FfiConverterTypeClientConfig = (() => {
  type TypeName = ClientConfig;
  class FFIConverter extends AbstractFfiConverterByteArray<TypeName> {
    read(from: RustBuffer): TypeName {
      return {
        groupStateStorage: FfiConverterTypeGroupStateStorage.read(from),
        keyPackageStorage: FfiConverterTypeKeyPackageStorage.read(from),
        useRatchetTreeExtension: FfiConverterBool.read(from),
      };
    }
    write(value: TypeName, into: RustBuffer): void {
      FfiConverterTypeGroupStateStorage.write(value.groupStateStorage, into);
      FfiConverterTypeKeyPackageStorage.write(value.keyPackageStorage, into);
      FfiConverterBool.write(value.useRatchetTreeExtension, into);
    }
    allocationSize(value: TypeName): number {
      return (
        FfiConverterTypeGroupStateStorage.allocationSize(value.groupStateStorage) +
        FfiConverterTypeKeyPackageStorage.allocationSize(value.keyPackageStorage) +
        FfiConverterBool.allocationSize(value.useRatchetTreeExtension)
      );
    }
  }
  return new FFIConverter();
})();

export type CommitOutput = {
  /**
   * Commit message to send to other group members.
   */
  commitMessage: MessageInterface;
  /**
   * Welcome message to send to new group members. This will be
   * `None` if the commit did not add new members.
   */
  welcomeMessage: MessageInterface | undefined;
  /**
   * Welcome messages to send to new group members. This will be
   * empty if the commit did not add new members.
   */
  welcomeMessages: Array<MessageInterface>;
  /**
   * Ratchet tree that can be sent out of band if the ratchet tree
   * extension is not used.
   */
  ratchetTree: RatchetTree | undefined;
  /**
   * A group info that can be provided to new members in order to
   * enable external commit functionality.
   */
  groupInfo: MessageInterface | undefined;
};

/**
 * Generated factory for {@link CommitOutput} record objects.
 */
export const CommitOutput = (() => {
  const defaults = () => ({});
  const create = (() => {
    return uniffiCreateRecord<CommitOutput, ReturnType<typeof defaults>>(defaults);
  })();
  return Object.freeze({
    /**
     * Create a frozen instance of {@link CommitOutput}, with defaults specified
     * in Rust, in the {@link mls_rs_uniffi} crate.
     */
    create,

    /**
     * Create a frozen instance of {@link CommitOutput}, with defaults specified
     * in Rust, in the {@link mls_rs_uniffi} crate.
     */
    new: create,

    /**
     * Defaults specified in the {@link mls_rs_uniffi} crate.
     */
    defaults: () => Object.freeze(defaults()) as Partial<CommitOutput>,
  });
})();

const FfiConverterTypeCommitOutput = (() => {
  type TypeName = CommitOutput;
  class FFIConverter extends AbstractFfiConverterByteArray<TypeName> {
    read(from: RustBuffer): TypeName {
      return {
        commitMessage: FfiConverterTypeMessage.read(from),
        welcomeMessage: FfiConverterOptionalTypeMessage.read(from),
        welcomeMessages: FfiConverterArrayTypeMessage.read(from),
        ratchetTree: FfiConverterOptionalTypeRatchetTree.read(from),
        groupInfo: FfiConverterOptionalTypeMessage.read(from),
      };
    }
    write(value: TypeName, into: RustBuffer): void {
      FfiConverterTypeMessage.write(value.commitMessage, into);
      FfiConverterOptionalTypeMessage.write(value.welcomeMessage, into);
      FfiConverterArrayTypeMessage.write(value.welcomeMessages, into);
      FfiConverterOptionalTypeRatchetTree.write(value.ratchetTree, into);
      FfiConverterOptionalTypeMessage.write(value.groupInfo, into);
    }
    allocationSize(value: TypeName): number {
      return (
        FfiConverterTypeMessage.allocationSize(value.commitMessage) +
        FfiConverterOptionalTypeMessage.allocationSize(value.welcomeMessage) +
        FfiConverterArrayTypeMessage.allocationSize(value.welcomeMessages) +
        FfiConverterOptionalTypeRatchetTree.allocationSize(value.ratchetTree) +
        FfiConverterOptionalTypeMessage.allocationSize(value.groupInfo)
      );
    }
  }
  return new FFIConverter();
})();

export type EpochRecord = {
  /**
   * A unique epoch identifier within a particular group.
   */
  id: /*u64*/ bigint;
  data: ArrayBuffer;
};

/**
 * Generated factory for {@link EpochRecord} record objects.
 */
export const EpochRecord = (() => {
  const defaults = () => ({});
  const create = (() => {
    return uniffiCreateRecord<EpochRecord, ReturnType<typeof defaults>>(defaults);
  })();
  return Object.freeze({
    /**
     * Create a frozen instance of {@link EpochRecord}, with defaults specified
     * in Rust, in the {@link mls_rs_uniffi} crate.
     */
    create,

    /**
     * Create a frozen instance of {@link EpochRecord}, with defaults specified
     * in Rust, in the {@link mls_rs_uniffi} crate.
     */
    new: create,

    /**
     * Defaults specified in the {@link mls_rs_uniffi} crate.
     */
    defaults: () => Object.freeze(defaults()) as Partial<EpochRecord>,
  });
})();

const FfiConverterTypeEpochRecord = (() => {
  type TypeName = EpochRecord;
  class FFIConverter extends AbstractFfiConverterByteArray<TypeName> {
    read(from: RustBuffer): TypeName {
      return {
        id: FfiConverterUInt64.read(from),
        data: FfiConverterArrayBuffer.read(from),
      };
    }
    write(value: TypeName, into: RustBuffer): void {
      FfiConverterUInt64.write(value.id, into);
      FfiConverterArrayBuffer.write(value.data, into);
    }
    allocationSize(value: TypeName): number {
      return (
        FfiConverterUInt64.allocationSize(value.id) +
        FfiConverterArrayBuffer.allocationSize(value.data)
      );
    }
  }
  return new FFIConverter();
})();

export type GroupMemberInfo = {
  index: /*u32*/ number;
  signingIdentity: SigningIdentityInterface;
  identifier: ArrayBuffer;
  signaturePublicKey: SignaturePublicKey;
};

/**
 * Generated factory for {@link GroupMemberInfo} record objects.
 */
export const GroupMemberInfo = (() => {
  const defaults = () => ({});
  const create = (() => {
    return uniffiCreateRecord<GroupMemberInfo, ReturnType<typeof defaults>>(defaults);
  })();
  return Object.freeze({
    /**
     * Create a frozen instance of {@link GroupMemberInfo}, with defaults specified
     * in Rust, in the {@link mls_rs_uniffi} crate.
     */
    create,

    /**
     * Create a frozen instance of {@link GroupMemberInfo}, with defaults specified
     * in Rust, in the {@link mls_rs_uniffi} crate.
     */
    new: create,

    /**
     * Defaults specified in the {@link mls_rs_uniffi} crate.
     */
    defaults: () => Object.freeze(defaults()) as Partial<GroupMemberInfo>,
  });
})();

const FfiConverterTypeGroupMemberInfo = (() => {
  type TypeName = GroupMemberInfo;
  class FFIConverter extends AbstractFfiConverterByteArray<TypeName> {
    read(from: RustBuffer): TypeName {
      return {
        index: FfiConverterUInt32.read(from),
        signingIdentity: FfiConverterTypeSigningIdentity.read(from),
        identifier: FfiConverterArrayBuffer.read(from),
        signaturePublicKey: FfiConverterTypeSignaturePublicKey.read(from),
      };
    }
    write(value: TypeName, into: RustBuffer): void {
      FfiConverterUInt32.write(value.index, into);
      FfiConverterTypeSigningIdentity.write(value.signingIdentity, into);
      FfiConverterArrayBuffer.write(value.identifier, into);
      FfiConverterTypeSignaturePublicKey.write(value.signaturePublicKey, into);
    }
    allocationSize(value: TypeName): number {
      return (
        FfiConverterUInt32.allocationSize(value.index) +
        FfiConverterTypeSigningIdentity.allocationSize(value.signingIdentity) +
        FfiConverterArrayBuffer.allocationSize(value.identifier) +
        FfiConverterTypeSignaturePublicKey.allocationSize(value.signaturePublicKey)
      );
    }
  }
  return new FFIConverter();
})();

/**
 * A [`mls_rs::Group`] and [`mls_rs::group::NewMemberInfo`] wrapper.
 */
export type JoinInfo = {
  /**
   * The group that was joined.
   */
  group: GroupInterface;
  /**
   * Group info extensions found within the Welcome message used to join
   * the group.
   */
  groupInfoExtensions: ExtensionListInterface;
};

/**
 * Generated factory for {@link JoinInfo} record objects.
 */
export const JoinInfo = (() => {
  const defaults = () => ({});
  const create = (() => {
    return uniffiCreateRecord<JoinInfo, ReturnType<typeof defaults>>(defaults);
  })();
  return Object.freeze({
    /**
     * Create a frozen instance of {@link JoinInfo}, with defaults specified
     * in Rust, in the {@link mls_rs_uniffi} crate.
     */
    create,

    /**
     * Create a frozen instance of {@link JoinInfo}, with defaults specified
     * in Rust, in the {@link mls_rs_uniffi} crate.
     */
    new: create,

    /**
     * Defaults specified in the {@link mls_rs_uniffi} crate.
     */
    defaults: () => Object.freeze(defaults()) as Partial<JoinInfo>,
  });
})();

const FfiConverterTypeJoinInfo = (() => {
  type TypeName = JoinInfo;
  class FFIConverter extends AbstractFfiConverterByteArray<TypeName> {
    read(from: RustBuffer): TypeName {
      return {
        group: FfiConverterTypeGroup.read(from),
        groupInfoExtensions: FfiConverterTypeExtensionList.read(from),
      };
    }
    write(value: TypeName, into: RustBuffer): void {
      FfiConverterTypeGroup.write(value.group, into);
      FfiConverterTypeExtensionList.write(value.groupInfoExtensions, into);
    }
    allocationSize(value: TypeName): number {
      return (
        FfiConverterTypeGroup.allocationSize(value.group) +
        FfiConverterTypeExtensionList.allocationSize(value.groupInfoExtensions)
      );
    }
  }
  return new FFIConverter();
})();

export type RatchetTree = {
  bytes: ArrayBuffer;
};

/**
 * Generated factory for {@link RatchetTree} record objects.
 */
export const RatchetTree = (() => {
  const defaults = () => ({});
  const create = (() => {
    return uniffiCreateRecord<RatchetTree, ReturnType<typeof defaults>>(defaults);
  })();
  return Object.freeze({
    /**
     * Create a frozen instance of {@link RatchetTree}, with defaults specified
     * in Rust, in the {@link mls_rs_uniffi} crate.
     */
    create,

    /**
     * Create a frozen instance of {@link RatchetTree}, with defaults specified
     * in Rust, in the {@link mls_rs_uniffi} crate.
     */
    new: create,

    /**
     * Defaults specified in the {@link mls_rs_uniffi} crate.
     */
    defaults: () => Object.freeze(defaults()) as Partial<RatchetTree>,
  });
})();

const FfiConverterTypeRatchetTree = (() => {
  type TypeName = RatchetTree;
  class FFIConverter extends AbstractFfiConverterByteArray<TypeName> {
    read(from: RustBuffer): TypeName {
      return {
        bytes: FfiConverterArrayBuffer.read(from),
      };
    }
    write(value: TypeName, into: RustBuffer): void {
      FfiConverterArrayBuffer.write(value.bytes, into);
    }
    allocationSize(value: TypeName): number {
      return FfiConverterArrayBuffer.allocationSize(value.bytes);
    }
  }
  return new FFIConverter();
})();

/**
 * A ([`SignaturePublicKey`], [`SignatureSecretKey`]) pair.
 */
export type SignatureKeypair = {
  cipherSuite: CipherSuite;
  publicKey: SignaturePublicKey;
  secretKey: SignatureSecretKey;
};

/**
 * Generated factory for {@link SignatureKeypair} record objects.
 */
export const SignatureKeypair = (() => {
  const defaults = () => ({});
  const create = (() => {
    return uniffiCreateRecord<SignatureKeypair, ReturnType<typeof defaults>>(defaults);
  })();
  return Object.freeze({
    /**
     * Create a frozen instance of {@link SignatureKeypair}, with defaults specified
     * in Rust, in the {@link mls_rs_uniffi} crate.
     */
    create,

    /**
     * Create a frozen instance of {@link SignatureKeypair}, with defaults specified
     * in Rust, in the {@link mls_rs_uniffi} crate.
     */
    new: create,

    /**
     * Defaults specified in the {@link mls_rs_uniffi} crate.
     */
    defaults: () => Object.freeze(defaults()) as Partial<SignatureKeypair>,
  });
})();

const FfiConverterTypeSignatureKeypair = (() => {
  type TypeName = SignatureKeypair;
  class FFIConverter extends AbstractFfiConverterByteArray<TypeName> {
    read(from: RustBuffer): TypeName {
      return {
        cipherSuite: FfiConverterTypeCipherSuite.read(from),
        publicKey: FfiConverterTypeSignaturePublicKey.read(from),
        secretKey: FfiConverterTypeSignatureSecretKey.read(from),
      };
    }
    write(value: TypeName, into: RustBuffer): void {
      FfiConverterTypeCipherSuite.write(value.cipherSuite, into);
      FfiConverterTypeSignaturePublicKey.write(value.publicKey, into);
      FfiConverterTypeSignatureSecretKey.write(value.secretKey, into);
    }
    allocationSize(value: TypeName): number {
      return (
        FfiConverterTypeCipherSuite.allocationSize(value.cipherSuite) +
        FfiConverterTypeSignaturePublicKey.allocationSize(value.publicKey) +
        FfiConverterTypeSignatureSecretKey.allocationSize(value.secretKey)
      );
    }
  }
  return new FFIConverter();
})();

/**
 * A [`mls_rs::crypto::SignaturePublicKey`] wrapper.
 */
export type SignaturePublicKey = {
  bytes: ArrayBuffer;
};

/**
 * Generated factory for {@link SignaturePublicKey} record objects.
 */
export const SignaturePublicKey = (() => {
  const defaults = () => ({});
  const create = (() => {
    return uniffiCreateRecord<SignaturePublicKey, ReturnType<typeof defaults>>(defaults);
  })();
  return Object.freeze({
    /**
     * Create a frozen instance of {@link SignaturePublicKey}, with defaults specified
     * in Rust, in the {@link mls_rs_uniffi} crate.
     */
    create,

    /**
     * Create a frozen instance of {@link SignaturePublicKey}, with defaults specified
     * in Rust, in the {@link mls_rs_uniffi} crate.
     */
    new: create,

    /**
     * Defaults specified in the {@link mls_rs_uniffi} crate.
     */
    defaults: () => Object.freeze(defaults()) as Partial<SignaturePublicKey>,
  });
})();

const FfiConverterTypeSignaturePublicKey = (() => {
  type TypeName = SignaturePublicKey;
  class FFIConverter extends AbstractFfiConverterByteArray<TypeName> {
    read(from: RustBuffer): TypeName {
      return {
        bytes: FfiConverterArrayBuffer.read(from),
      };
    }
    write(value: TypeName, into: RustBuffer): void {
      FfiConverterArrayBuffer.write(value.bytes, into);
    }
    allocationSize(value: TypeName): number {
      return FfiConverterArrayBuffer.allocationSize(value.bytes);
    }
  }
  return new FFIConverter();
})();

/**
 * A [`mls_rs::crypto::SignatureSecretKey`] wrapper.
 */
export type SignatureSecretKey = {
  bytes: ArrayBuffer;
};

/**
 * Generated factory for {@link SignatureSecretKey} record objects.
 */
export const SignatureSecretKey = (() => {
  const defaults = () => ({});
  const create = (() => {
    return uniffiCreateRecord<SignatureSecretKey, ReturnType<typeof defaults>>(defaults);
  })();
  return Object.freeze({
    /**
     * Create a frozen instance of {@link SignatureSecretKey}, with defaults specified
     * in Rust, in the {@link mls_rs_uniffi} crate.
     */
    create,

    /**
     * Create a frozen instance of {@link SignatureSecretKey}, with defaults specified
     * in Rust, in the {@link mls_rs_uniffi} crate.
     */
    new: create,

    /**
     * Defaults specified in the {@link mls_rs_uniffi} crate.
     */
    defaults: () => Object.freeze(defaults()) as Partial<SignatureSecretKey>,
  });
})();

const FfiConverterTypeSignatureSecretKey = (() => {
  type TypeName = SignatureSecretKey;
  class FFIConverter extends AbstractFfiConverterByteArray<TypeName> {
    read(from: RustBuffer): TypeName {
      return {
        bytes: FfiConverterArrayBuffer.read(from),
      };
    }
    write(value: TypeName, into: RustBuffer): void {
      FfiConverterArrayBuffer.write(value.bytes, into);
    }
    allocationSize(value: TypeName): number {
      return FfiConverterArrayBuffer.allocationSize(value.bytes);
    }
  }
  return new FFIConverter();
})();

const stringConverter = (() => {
  const encoder = new TextEncoder();
  const decoder = new TextDecoder();
  return {
    stringToBytes: (s: string) => encoder.encode(s),
    bytesToString: (ab: UniffiByteArray) => decoder.decode(ab),
    stringByteLength: (s: string) => encoder.encode(s).byteLength,
  };
})();
const FfiConverterString = uniffiCreateFfiConverterString(stringConverter);

/**
 * Supported cipher suites.
 *
 * This is a subset of the cipher suites found in
 * [`mls_rs::CipherSuite`].
 */
export enum CipherSuite {
  Curve25519Aes128,
}

const FfiConverterTypeCipherSuite = (() => {
  const ordinalConverter = FfiConverterInt32;
  type TypeName = CipherSuite;
  class FFIConverter extends AbstractFfiConverterByteArray<TypeName> {
    read(from: RustBuffer): TypeName {
      switch (ordinalConverter.read(from)) {
        case 1:
          return CipherSuite.Curve25519Aes128;
        default:
          throw new UniffiInternalError.UnexpectedEnumCase();
      }
    }
    write(value: TypeName, into: RustBuffer): void {
      switch (value) {
        case CipherSuite.Curve25519Aes128:
          return ordinalConverter.write(1, into);
      }
    }
    allocationSize(value: TypeName): number {
      return ordinalConverter.allocationSize(0);
    }
  }
  return new FFIConverter();
})();

// Enum: CommitEffect
export enum CommitEffect_Tags {
  NewEpoch = 'NewEpoch',
  ReInit = 'ReInit',
  Removed = 'Removed',
}
export const CommitEffect = (() => {
  type NewEpoch__interface = {
    tag: CommitEffect_Tags.NewEpoch;
    inner: Readonly<{
      appliedProposals: Array<ProposalInterface>;
      unusedProposals: Array<ProposalInterface>;
    }>;
  };

  class NewEpoch_ extends UniffiEnum implements NewEpoch__interface {
    /**
     * @private
     * This field is private and should not be used, use `tag` instead.
     */
    readonly [uniffiTypeNameSymbol] = 'CommitEffect';
    readonly tag = CommitEffect_Tags.NewEpoch;
    readonly inner: Readonly<{
      appliedProposals: Array<ProposalInterface>;
      unusedProposals: Array<ProposalInterface>;
    }>;
    constructor(inner: {
      appliedProposals: Array<ProposalInterface>;
      unusedProposals: Array<ProposalInterface>;
    }) {
      super('CommitEffect', 'NewEpoch');
      this.inner = Object.freeze(inner);
    }

    static new(inner: {
      appliedProposals: Array<ProposalInterface>;
      unusedProposals: Array<ProposalInterface>;
    }): NewEpoch_ {
      return new NewEpoch_(inner);
    }

    static instanceOf(obj: any): obj is NewEpoch_ {
      return obj.tag === CommitEffect_Tags.NewEpoch;
    }
  }

  type ReInit__interface = {
    tag: CommitEffect_Tags.ReInit;
  };

  class ReInit_ extends UniffiEnum implements ReInit__interface {
    /**
     * @private
     * This field is private and should not be used, use `tag` instead.
     */
    readonly [uniffiTypeNameSymbol] = 'CommitEffect';
    readonly tag = CommitEffect_Tags.ReInit;
    constructor() {
      super('CommitEffect', 'ReInit');
    }

    static new(): ReInit_ {
      return new ReInit_();
    }

    static instanceOf(obj: any): obj is ReInit_ {
      return obj.tag === CommitEffect_Tags.ReInit;
    }
  }

  type Removed__interface = {
    tag: CommitEffect_Tags.Removed;
  };

  class Removed_ extends UniffiEnum implements Removed__interface {
    /**
     * @private
     * This field is private and should not be used, use `tag` instead.
     */
    readonly [uniffiTypeNameSymbol] = 'CommitEffect';
    readonly tag = CommitEffect_Tags.Removed;
    constructor() {
      super('CommitEffect', 'Removed');
    }

    static new(): Removed_ {
      return new Removed_();
    }

    static instanceOf(obj: any): obj is Removed_ {
      return obj.tag === CommitEffect_Tags.Removed;
    }
  }

  function instanceOf(obj: any): obj is CommitEffect {
    return obj[uniffiTypeNameSymbol] === 'CommitEffect';
  }

  return Object.freeze({
    instanceOf,
    NewEpoch: NewEpoch_,
    ReInit: ReInit_,
    Removed: Removed_,
  });
})();

export type CommitEffect = InstanceType<
  (typeof CommitEffect)[keyof Omit<typeof CommitEffect, 'instanceOf'>]
>;

// FfiConverter for enum CommitEffect
const FfiConverterTypeCommitEffect = (() => {
  const ordinalConverter = FfiConverterInt32;
  type TypeName = CommitEffect;
  class FFIConverter extends AbstractFfiConverterByteArray<TypeName> {
    read(from: RustBuffer): TypeName {
      switch (ordinalConverter.read(from)) {
        case 1:
          return new CommitEffect.NewEpoch({
            appliedProposals: FfiConverterArrayTypeProposal.read(from),
            unusedProposals: FfiConverterArrayTypeProposal.read(from),
          });
        case 2:
          return new CommitEffect.ReInit();
        case 3:
          return new CommitEffect.Removed();
        default:
          throw new UniffiInternalError.UnexpectedEnumCase();
      }
    }
    write(value: TypeName, into: RustBuffer): void {
      switch (value.tag) {
        case CommitEffect_Tags.NewEpoch: {
          ordinalConverter.write(1, into);
          const inner = value.inner;
          FfiConverterArrayTypeProposal.write(inner.appliedProposals, into);
          FfiConverterArrayTypeProposal.write(inner.unusedProposals, into);
          return;
        }
        case CommitEffect_Tags.ReInit: {
          ordinalConverter.write(2, into);
          return;
        }
        case CommitEffect_Tags.Removed: {
          ordinalConverter.write(3, into);
          return;
        }
        default:
          // Throwing from here means that CommitEffect_Tags hasn't matched an ordinal.
          throw new UniffiInternalError.UnexpectedEnumCase();
      }
    }
    allocationSize(value: TypeName): number {
      switch (value.tag) {
        case CommitEffect_Tags.NewEpoch: {
          const inner = value.inner;
          let size = ordinalConverter.allocationSize(1);
          size += FfiConverterArrayTypeProposal.allocationSize(inner.appliedProposals);
          size += FfiConverterArrayTypeProposal.allocationSize(inner.unusedProposals);
          return size;
        }
        case CommitEffect_Tags.ReInit: {
          return ordinalConverter.allocationSize(2);
        }
        case CommitEffect_Tags.Removed: {
          return ordinalConverter.allocationSize(3);
        }
        default:
          throw new UniffiInternalError.UnexpectedEnumCase();
      }
    }
  }
  return new FFIConverter();
})();

// Flat error type: Exception
export enum Exception_Tags {
  MlsError = 'MlsError',
  AnyError = 'AnyError',
  MlsCodecError = 'MlsCodecError',
  UnexpectedCallbackError = 'UnexpectedCallbackError',
}
export const Exception = (() => {
  class MlsError extends UniffiError {
    /**
     * @private
     * This field is private and should not be used.
     */
    readonly [uniffiTypeNameSymbol]: string = 'Exception';
    /**
     * @private
     * This field is private and should not be used.
     */
    readonly [variantOrdinalSymbol] = 1;

    public readonly tag = Exception_Tags.MlsError;

    constructor(message: string) {
      super('Exception', 'MlsError', message);
    }

    static instanceOf(e: any): e is MlsError {
      return instanceOf(e) && (e as any)[variantOrdinalSymbol] === 1;
    }
  }
  class AnyError extends UniffiError {
    /**
     * @private
     * This field is private and should not be used.
     */
    readonly [uniffiTypeNameSymbol]: string = 'Exception';
    /**
     * @private
     * This field is private and should not be used.
     */
    readonly [variantOrdinalSymbol] = 2;

    public readonly tag = Exception_Tags.AnyError;

    constructor(message: string) {
      super('Exception', 'AnyError', message);
    }

    static instanceOf(e: any): e is AnyError {
      return instanceOf(e) && (e as any)[variantOrdinalSymbol] === 2;
    }
  }
  class MlsCodecError extends UniffiError {
    /**
     * @private
     * This field is private and should not be used.
     */
    readonly [uniffiTypeNameSymbol]: string = 'Exception';
    /**
     * @private
     * This field is private and should not be used.
     */
    readonly [variantOrdinalSymbol] = 3;

    public readonly tag = Exception_Tags.MlsCodecError;

    constructor(message: string) {
      super('Exception', 'MlsCodecError', message);
    }

    static instanceOf(e: any): e is MlsCodecError {
      return instanceOf(e) && (e as any)[variantOrdinalSymbol] === 3;
    }
  }
  class UnexpectedCallbackError extends UniffiError {
    /**
     * @private
     * This field is private and should not be used.
     */
    readonly [uniffiTypeNameSymbol]: string = 'Exception';
    /**
     * @private
     * This field is private and should not be used.
     */
    readonly [variantOrdinalSymbol] = 4;

    public readonly tag = Exception_Tags.UnexpectedCallbackError;

    constructor(message: string) {
      super('Exception', 'UnexpectedCallbackError', message);
    }

    static instanceOf(e: any): e is UnexpectedCallbackError {
      return instanceOf(e) && (e as any)[variantOrdinalSymbol] === 4;
    }
  }

  // Utility function which does not rely on instanceof.
  function instanceOf(e: any): e is Exception {
    return (e as any)[uniffiTypeNameSymbol] === 'Exception';
  }
  return {
    MlsError,
    AnyError,
    MlsCodecError,
    UnexpectedCallbackError,
    instanceOf,
  };
})();

// Union type for Exception error type.

export type Exception = InstanceType<
  (typeof Exception)[keyof Omit<typeof Exception, 'instanceOf'>]
>;

const FfiConverterTypeError = (() => {
  const intConverter = FfiConverterInt32;
  type TypeName = Exception;
  class FfiConverter extends AbstractFfiConverterByteArray<TypeName> {
    read(from: RustBuffer): TypeName {
      switch (intConverter.read(from)) {
        case 1:
          return new Exception.MlsError(FfiConverterString.read(from));

        case 2:
          return new Exception.AnyError(FfiConverterString.read(from));

        case 3:
          return new Exception.MlsCodecError(FfiConverterString.read(from));

        case 4:
          return new Exception.UnexpectedCallbackError(FfiConverterString.read(from));

        default:
          throw new UniffiInternalError.UnexpectedEnumCase();
      }
    }
    write(value: TypeName, into: RustBuffer): void {
      const obj = value as any;
      const index = obj[variantOrdinalSymbol] as number;
      intConverter.write(index, into);
    }
    allocationSize(value: TypeName): number {
      return intConverter.allocationSize(0);
    }
  }
  return new FfiConverter();
})();

export enum ProtocolVersion {
  /**
   * MLS version 1.0.
   */
  Mls10,
}

const FfiConverterTypeProtocolVersion = (() => {
  const ordinalConverter = FfiConverterInt32;
  type TypeName = ProtocolVersion;
  class FFIConverter extends AbstractFfiConverterByteArray<TypeName> {
    read(from: RustBuffer): TypeName {
      switch (ordinalConverter.read(from)) {
        case 1:
          return ProtocolVersion.Mls10;
        default:
          throw new UniffiInternalError.UnexpectedEnumCase();
      }
    }
    write(value: TypeName, into: RustBuffer): void {
      switch (value) {
        case ProtocolVersion.Mls10:
          return ordinalConverter.write(1, into);
      }
    }
    allocationSize(value: TypeName): number {
      return ordinalConverter.allocationSize(0);
    }
  }
  return new FFIConverter();
})();

// Enum: ReceivedMessage
export enum ReceivedMessage_Tags {
  ApplicationMessage = 'ApplicationMessage',
  Commit = 'Commit',
  ReceivedProposal = 'ReceivedProposal',
  GroupInfo = 'GroupInfo',
  Welcome = 'Welcome',
  KeyPackage = 'KeyPackage',
}
/**
 * A [`mls_rs::group::ReceivedMessage`] wrapper.
 */
export const ReceivedMessage = (() => {
  type ApplicationMessage__interface = {
    tag: ReceivedMessage_Tags.ApplicationMessage;
    inner: Readonly<{ sender: SigningIdentityInterface; data: ArrayBuffer }>;
  };

  /**
   * A decrypted application message.
   *
   * The encoding of the data in the message is
   * application-specific and is not determined by MLS.
   */
  class ApplicationMessage_ extends UniffiEnum implements ApplicationMessage__interface {
    /**
     * @private
     * This field is private and should not be used, use `tag` instead.
     */
    readonly [uniffiTypeNameSymbol] = 'ReceivedMessage';
    readonly tag = ReceivedMessage_Tags.ApplicationMessage;
    readonly inner: Readonly<{ sender: SigningIdentityInterface; data: ArrayBuffer }>;
    constructor(inner: { sender: SigningIdentityInterface; data: ArrayBuffer }) {
      super('ReceivedMessage', 'ApplicationMessage');
      this.inner = Object.freeze(inner);
    }

    static new(inner: {
      sender: SigningIdentityInterface;
      data: ArrayBuffer;
    }): ApplicationMessage_ {
      return new ApplicationMessage_(inner);
    }

    static instanceOf(obj: any): obj is ApplicationMessage_ {
      return obj.tag === ReceivedMessage_Tags.ApplicationMessage;
    }
  }

  type Commit__interface = {
    tag: ReceivedMessage_Tags.Commit;
    inner: Readonly<{ committer: SigningIdentityInterface; effect: CommitEffect }>;
  };

  /**
   * A new commit was processed creating a new group state.
   */
  class Commit_ extends UniffiEnum implements Commit__interface {
    /**
     * @private
     * This field is private and should not be used, use `tag` instead.
     */
    readonly [uniffiTypeNameSymbol] = 'ReceivedMessage';
    readonly tag = ReceivedMessage_Tags.Commit;
    readonly inner: Readonly<{ committer: SigningIdentityInterface; effect: CommitEffect }>;
    constructor(inner: { committer: SigningIdentityInterface; effect: CommitEffect }) {
      super('ReceivedMessage', 'Commit');
      this.inner = Object.freeze(inner);
    }

    static new(inner: { committer: SigningIdentityInterface; effect: CommitEffect }): Commit_ {
      return new Commit_(inner);
    }

    static instanceOf(obj: any): obj is Commit_ {
      return obj.tag === ReceivedMessage_Tags.Commit;
    }
  }

  type ReceivedProposal__interface = {
    tag: ReceivedMessage_Tags.ReceivedProposal;
    inner: Readonly<{ sender: SigningIdentityInterface; proposal: ProposalInterface }>;
  };

  /**
   * A proposal was received.
   */
  class ReceivedProposal_ extends UniffiEnum implements ReceivedProposal__interface {
    /**
     * @private
     * This field is private and should not be used, use `tag` instead.
     */
    readonly [uniffiTypeNameSymbol] = 'ReceivedMessage';
    readonly tag = ReceivedMessage_Tags.ReceivedProposal;
    readonly inner: Readonly<{ sender: SigningIdentityInterface; proposal: ProposalInterface }>;
    constructor(inner: { sender: SigningIdentityInterface; proposal: ProposalInterface }) {
      super('ReceivedMessage', 'ReceivedProposal');
      this.inner = Object.freeze(inner);
    }

    static new(inner: {
      sender: SigningIdentityInterface;
      proposal: ProposalInterface;
    }): ReceivedProposal_ {
      return new ReceivedProposal_(inner);
    }

    static instanceOf(obj: any): obj is ReceivedProposal_ {
      return obj.tag === ReceivedMessage_Tags.ReceivedProposal;
    }
  }

  type GroupInfo__interface = {
    tag: ReceivedMessage_Tags.GroupInfo;
  };

  /**
   * Validated GroupInfo object.
   */
  class GroupInfo_ extends UniffiEnum implements GroupInfo__interface {
    /**
     * @private
     * This field is private and should not be used, use `tag` instead.
     */
    readonly [uniffiTypeNameSymbol] = 'ReceivedMessage';
    readonly tag = ReceivedMessage_Tags.GroupInfo;
    constructor() {
      super('ReceivedMessage', 'GroupInfo');
    }

    static new(): GroupInfo_ {
      return new GroupInfo_();
    }

    static instanceOf(obj: any): obj is GroupInfo_ {
      return obj.tag === ReceivedMessage_Tags.GroupInfo;
    }
  }

  type Welcome__interface = {
    tag: ReceivedMessage_Tags.Welcome;
  };

  /**
   * Validated welcome message.
   */
  class Welcome_ extends UniffiEnum implements Welcome__interface {
    /**
     * @private
     * This field is private and should not be used, use `tag` instead.
     */
    readonly [uniffiTypeNameSymbol] = 'ReceivedMessage';
    readonly tag = ReceivedMessage_Tags.Welcome;
    constructor() {
      super('ReceivedMessage', 'Welcome');
    }

    static new(): Welcome_ {
      return new Welcome_();
    }

    static instanceOf(obj: any): obj is Welcome_ {
      return obj.tag === ReceivedMessage_Tags.Welcome;
    }
  }

  type KeyPackage__interface = {
    tag: ReceivedMessage_Tags.KeyPackage;
  };

  /**
   * Validated key package.
   */
  class KeyPackage_ extends UniffiEnum implements KeyPackage__interface {
    /**
     * @private
     * This field is private and should not be used, use `tag` instead.
     */
    readonly [uniffiTypeNameSymbol] = 'ReceivedMessage';
    readonly tag = ReceivedMessage_Tags.KeyPackage;
    constructor() {
      super('ReceivedMessage', 'KeyPackage');
    }

    static new(): KeyPackage_ {
      return new KeyPackage_();
    }

    static instanceOf(obj: any): obj is KeyPackage_ {
      return obj.tag === ReceivedMessage_Tags.KeyPackage;
    }
  }

  function instanceOf(obj: any): obj is ReceivedMessage {
    return obj[uniffiTypeNameSymbol] === 'ReceivedMessage';
  }

  return Object.freeze({
    instanceOf,
    ApplicationMessage: ApplicationMessage_,
    Commit: Commit_,
    ReceivedProposal: ReceivedProposal_,
    GroupInfo: GroupInfo_,
    Welcome: Welcome_,
    KeyPackage: KeyPackage_,
  });
})();

/**
 * A [`mls_rs::group::ReceivedMessage`] wrapper.
 */

export type ReceivedMessage = InstanceType<
  (typeof ReceivedMessage)[keyof Omit<typeof ReceivedMessage, 'instanceOf'>]
>;

// FfiConverter for enum ReceivedMessage
const FfiConverterTypeReceivedMessage = (() => {
  const ordinalConverter = FfiConverterInt32;
  type TypeName = ReceivedMessage;
  class FFIConverter extends AbstractFfiConverterByteArray<TypeName> {
    read(from: RustBuffer): TypeName {
      switch (ordinalConverter.read(from)) {
        case 1:
          return new ReceivedMessage.ApplicationMessage({
            sender: FfiConverterTypeSigningIdentity.read(from),
            data: FfiConverterArrayBuffer.read(from),
          });
        case 2:
          return new ReceivedMessage.Commit({
            committer: FfiConverterTypeSigningIdentity.read(from),
            effect: FfiConverterTypeCommitEffect.read(from),
          });
        case 3:
          return new ReceivedMessage.ReceivedProposal({
            sender: FfiConverterTypeSigningIdentity.read(from),
            proposal: FfiConverterTypeProposal.read(from),
          });
        case 4:
          return new ReceivedMessage.GroupInfo();
        case 5:
          return new ReceivedMessage.Welcome();
        case 6:
          return new ReceivedMessage.KeyPackage();
        default:
          throw new UniffiInternalError.UnexpectedEnumCase();
      }
    }
    write(value: TypeName, into: RustBuffer): void {
      switch (value.tag) {
        case ReceivedMessage_Tags.ApplicationMessage: {
          ordinalConverter.write(1, into);
          const inner = value.inner;
          FfiConverterTypeSigningIdentity.write(inner.sender, into);
          FfiConverterArrayBuffer.write(inner.data, into);
          return;
        }
        case ReceivedMessage_Tags.Commit: {
          ordinalConverter.write(2, into);
          const inner = value.inner;
          FfiConverterTypeSigningIdentity.write(inner.committer, into);
          FfiConverterTypeCommitEffect.write(inner.effect, into);
          return;
        }
        case ReceivedMessage_Tags.ReceivedProposal: {
          ordinalConverter.write(3, into);
          const inner = value.inner;
          FfiConverterTypeSigningIdentity.write(inner.sender, into);
          FfiConverterTypeProposal.write(inner.proposal, into);
          return;
        }
        case ReceivedMessage_Tags.GroupInfo: {
          ordinalConverter.write(4, into);
          return;
        }
        case ReceivedMessage_Tags.Welcome: {
          ordinalConverter.write(5, into);
          return;
        }
        case ReceivedMessage_Tags.KeyPackage: {
          ordinalConverter.write(6, into);
          return;
        }
        default:
          // Throwing from here means that ReceivedMessage_Tags hasn't matched an ordinal.
          throw new UniffiInternalError.UnexpectedEnumCase();
      }
    }
    allocationSize(value: TypeName): number {
      switch (value.tag) {
        case ReceivedMessage_Tags.ApplicationMessage: {
          const inner = value.inner;
          let size = ordinalConverter.allocationSize(1);
          size += FfiConverterTypeSigningIdentity.allocationSize(inner.sender);
          size += FfiConverterArrayBuffer.allocationSize(inner.data);
          return size;
        }
        case ReceivedMessage_Tags.Commit: {
          const inner = value.inner;
          let size = ordinalConverter.allocationSize(2);
          size += FfiConverterTypeSigningIdentity.allocationSize(inner.committer);
          size += FfiConverterTypeCommitEffect.allocationSize(inner.effect);
          return size;
        }
        case ReceivedMessage_Tags.ReceivedProposal: {
          const inner = value.inner;
          let size = ordinalConverter.allocationSize(3);
          size += FfiConverterTypeSigningIdentity.allocationSize(inner.sender);
          size += FfiConverterTypeProposal.allocationSize(inner.proposal);
          return size;
        }
        case ReceivedMessage_Tags.GroupInfo: {
          return ordinalConverter.allocationSize(4);
        }
        case ReceivedMessage_Tags.Welcome: {
          return ordinalConverter.allocationSize(5);
        }
        case ReceivedMessage_Tags.KeyPackage: {
          return ordinalConverter.allocationSize(6);
        }
        default:
          throw new UniffiInternalError.UnexpectedEnumCase();
      }
    }
  }
  return new FFIConverter();
})();

/**
 * An MLS client used to create key packages and manage groups.
 *
 * See [`mls_rs::Client`] for details.
 */
export interface ClientInterface {
  /**
   * Create and immediately join a new group.
   *
   * If a group ID is not given, the underlying library will create
   * a unique ID for you.
   *
   * See [`mls_rs::Client::create_group`] and
   * [`mls_rs::Client::create_group_with_id`] for details.
   */
  createGroup(groupId: ArrayBuffer | undefined): /*throws*/ GroupInterface;
  /**
   * Generate a new key package for this client.
   *
   * The key package is represented in is MLS message form. It is
   * needed when joining a group and can be published to a server
   * so other clients can look it up.
   *
   * See [`mls_rs::Client::generate_key_package_message`] for
   * details.
   */
  generateKeyPackageMessage(): /*throws*/ MessageInterface;
  /**
   * Join an existing group.
   *
   * You must supply `ratchet_tree` if the client that created
   * `welcome_message` did not set `use_ratchet_tree_extension`.
   *
   * See [`mls_rs::Client::join_group`] for details.
   */
  joinGroup(
    ratchetTree: RatchetTree | undefined,
    welcomeMessage: MessageInterface
  ): /*throws*/ JoinInfo;
  /**
   * Load an existing group.
   *
   * See [`mls_rs::Client::load_group`] for details.
   */
  loadGroup(groupId: ArrayBuffer): /*throws*/ GroupInterface;
  signingIdentity(): /*throws*/ SigningIdentityInterface;
}

/**
 * An MLS client used to create key packages and manage groups.
 *
 * See [`mls_rs::Client`] for details.
 */
export class Client extends UniffiAbstractObject implements ClientInterface {
  readonly [uniffiTypeNameSymbol] = 'Client';
  readonly [destructorGuardSymbol]: UniffiRustArcPtr;
  readonly [pointerLiteralSymbol]: UnsafeMutableRawPointer;
  /**
   * Create a new client with callback-based storage.
   *
   * See [`mls_rs::Client::builder`] for details.
   */
  constructor(id: ArrayBuffer, signatureKeypair: SignatureKeypair, clientConfig: ClientConfig) {
    super();
    const pointer = uniffiCaller.rustCall(
      /*caller:*/ (callStatus) => {
        return nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_constructor_client_new(
          FfiConverterArrayBuffer.lower(id),
          FfiConverterTypeSignatureKeypair.lower(signatureKeypair),
          FfiConverterTypeClientConfig.lower(clientConfig),
          callStatus
        );
      },
      /*liftString:*/ FfiConverterString.lift
    );
    this[pointerLiteralSymbol] = pointer;
    this[destructorGuardSymbol] = uniffiTypeClientObjectFactory.bless(pointer);
  }

  /**
   * Create and immediately join a new group.
   *
   * If a group ID is not given, the underlying library will create
   * a unique ID for you.
   *
   * See [`mls_rs::Client::create_group`] and
   * [`mls_rs::Client::create_group_with_id`] for details.
   */
  public createGroup(groupId: ArrayBuffer | undefined): GroupInterface /*throws*/ {
    return FfiConverterTypeGroup.lift(
      uniffiCaller.rustCallWithError(
        /*liftError:*/ FfiConverterTypeError.lift.bind(FfiConverterTypeError),
        /*caller:*/ (callStatus) => {
          return nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_method_client_create_group(
            uniffiTypeClientObjectFactory.clonePointer(this),
            FfiConverterOptionalArrayBuffer.lower(groupId),
            callStatus
          );
        },
        /*liftString:*/ FfiConverterString.lift
      )
    );
  }

  /**
   * Generate a new key package for this client.
   *
   * The key package is represented in is MLS message form. It is
   * needed when joining a group and can be published to a server
   * so other clients can look it up.
   *
   * See [`mls_rs::Client::generate_key_package_message`] for
   * details.
   */
  public generateKeyPackageMessage(): MessageInterface /*throws*/ {
    return FfiConverterTypeMessage.lift(
      uniffiCaller.rustCallWithError(
        /*liftError:*/ FfiConverterTypeError.lift.bind(FfiConverterTypeError),
        /*caller:*/ (callStatus) => {
          return nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_method_client_generate_key_package_message(
            uniffiTypeClientObjectFactory.clonePointer(this),
            callStatus
          );
        },
        /*liftString:*/ FfiConverterString.lift
      )
    );
  }

  /**
   * Join an existing group.
   *
   * You must supply `ratchet_tree` if the client that created
   * `welcome_message` did not set `use_ratchet_tree_extension`.
   *
   * See [`mls_rs::Client::join_group`] for details.
   */
  public joinGroup(
    ratchetTree: RatchetTree | undefined,
    welcomeMessage: MessageInterface
  ): JoinInfo /*throws*/ {
    return FfiConverterTypeJoinInfo.lift(
      uniffiCaller.rustCallWithError(
        /*liftError:*/ FfiConverterTypeError.lift.bind(FfiConverterTypeError),
        /*caller:*/ (callStatus) => {
          return nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_method_client_join_group(
            uniffiTypeClientObjectFactory.clonePointer(this),
            FfiConverterOptionalTypeRatchetTree.lower(ratchetTree),
            FfiConverterTypeMessage.lower(welcomeMessage),
            callStatus
          );
        },
        /*liftString:*/ FfiConverterString.lift
      )
    );
  }

  /**
   * Load an existing group.
   *
   * See [`mls_rs::Client::load_group`] for details.
   */
  public loadGroup(groupId: ArrayBuffer): GroupInterface /*throws*/ {
    return FfiConverterTypeGroup.lift(
      uniffiCaller.rustCallWithError(
        /*liftError:*/ FfiConverterTypeError.lift.bind(FfiConverterTypeError),
        /*caller:*/ (callStatus) => {
          return nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_method_client_load_group(
            uniffiTypeClientObjectFactory.clonePointer(this),
            FfiConverterArrayBuffer.lower(groupId),
            callStatus
          );
        },
        /*liftString:*/ FfiConverterString.lift
      )
    );
  }

  public signingIdentity(): SigningIdentityInterface /*throws*/ {
    return FfiConverterTypeSigningIdentity.lift(
      uniffiCaller.rustCallWithError(
        /*liftError:*/ FfiConverterTypeError.lift.bind(FfiConverterTypeError),
        /*caller:*/ (callStatus) => {
          return nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_method_client_signing_identity(
            uniffiTypeClientObjectFactory.clonePointer(this),
            callStatus
          );
        },
        /*liftString:*/ FfiConverterString.lift
      )
    );
  }

  /**
   * {@inheritDoc uniffi-bindgen-react-native#UniffiAbstractObject.uniffiDestroy}
   */
  uniffiDestroy(): void {
    const ptr = (this as any)[destructorGuardSymbol];
    if (ptr !== undefined) {
      const pointer = uniffiTypeClientObjectFactory.pointer(this);
      uniffiTypeClientObjectFactory.freePointer(pointer);
      uniffiTypeClientObjectFactory.unbless(ptr);
      delete (this as any)[destructorGuardSymbol];
    }
  }

  static instanceOf(obj: any): obj is Client {
    return uniffiTypeClientObjectFactory.isConcreteType(obj);
  }
}

const uniffiTypeClientObjectFactory: UniffiObjectFactory<ClientInterface> = (() => {
  /// <reference lib="es2021" />
  const registry =
    typeof FinalizationRegistry !== 'undefined'
      ? new FinalizationRegistry<UnsafeMutableRawPointer>((heldValue: UnsafeMutableRawPointer) => {
          uniffiTypeClientObjectFactory.freePointer(heldValue);
        })
      : null;

  return {
    create(pointer: UnsafeMutableRawPointer): ClientInterface {
      const instance = Object.create(Client.prototype);
      instance[pointerLiteralSymbol] = pointer;
      instance[destructorGuardSymbol] = this.bless(pointer);
      instance[uniffiTypeNameSymbol] = 'Client';
      return instance;
    },

    bless(p: UnsafeMutableRawPointer): UniffiRustArcPtr {
      const ptr = {
        p, // make sure this object doesn't get optimized away.
        markDestroyed: () => undefined,
      };
      if (registry) {
        registry.register(ptr, p, ptr);
      }
      return ptr;
    },

    unbless(ptr: UniffiRustArcPtr) {
      if (registry) {
        registry.unregister(ptr);
      }
    },

    pointer(obj: ClientInterface): UnsafeMutableRawPointer {
      if ((obj as any)[destructorGuardSymbol] === undefined) {
        throw new UniffiInternalError.UnexpectedNullPointer();
      }
      return (obj as any)[pointerLiteralSymbol];
    },

    clonePointer(obj: ClientInterface): UnsafeMutableRawPointer {
      const pointer = this.pointer(obj);
      return uniffiCaller.rustCall(
        /*caller:*/ (callStatus) =>
          nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_clone_client(pointer, callStatus),
        /*liftString:*/ FfiConverterString.lift
      );
    },

    freePointer(pointer: UnsafeMutableRawPointer): void {
      uniffiCaller.rustCall(
        /*caller:*/ (callStatus) =>
          nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_free_client(pointer, callStatus),
        /*liftString:*/ FfiConverterString.lift
      );
    },

    isConcreteType(obj: any): obj is ClientInterface {
      return obj[destructorGuardSymbol] && obj[uniffiTypeNameSymbol] === 'Client';
    },
  };
})();
// FfiConverter for ClientInterface
const FfiConverterTypeClient = new FfiConverterObject(uniffiTypeClientObjectFactory);

export interface CommitBuilderInterface {
  addMember(keyPackage: MessageInterface): /*throws*/ void;
  addMembers(keyPackages: Array<MessageInterface>): /*throws*/ void;
  build(): /*throws*/ CommitOutput;
  removeMember(signingIdentity: SigningIdentityInterface): /*throws*/ void;
  removeMembers(signingIdentities: Array<SigningIdentityInterface>): /*throws*/ void;
}

export class CommitBuilder extends UniffiAbstractObject implements CommitBuilderInterface {
  readonly [uniffiTypeNameSymbol] = 'CommitBuilder';
  readonly [destructorGuardSymbol]: UniffiRustArcPtr;
  readonly [pointerLiteralSymbol]: UnsafeMutableRawPointer;
  // No primary constructor declared for this class.
  private constructor(pointer: UnsafeMutableRawPointer) {
    super();
    this[pointerLiteralSymbol] = pointer;
    this[destructorGuardSymbol] = uniffiTypeCommitBuilderObjectFactory.bless(pointer);
  }

  public addMember(keyPackage: MessageInterface): void /*throws*/ {
    uniffiCaller.rustCallWithError(
      /*liftError:*/ FfiConverterTypeError.lift.bind(FfiConverterTypeError),
      /*caller:*/ (callStatus) => {
        nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_method_commitbuilder_add_member(
          uniffiTypeCommitBuilderObjectFactory.clonePointer(this),
          FfiConverterTypeMessage.lower(keyPackage),
          callStatus
        );
      },
      /*liftString:*/ FfiConverterString.lift
    );
  }

  public addMembers(keyPackages: Array<MessageInterface>): void /*throws*/ {
    uniffiCaller.rustCallWithError(
      /*liftError:*/ FfiConverterTypeError.lift.bind(FfiConverterTypeError),
      /*caller:*/ (callStatus) => {
        nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_method_commitbuilder_add_members(
          uniffiTypeCommitBuilderObjectFactory.clonePointer(this),
          FfiConverterArrayTypeMessage.lower(keyPackages),
          callStatus
        );
      },
      /*liftString:*/ FfiConverterString.lift
    );
  }

  public build(): CommitOutput /*throws*/ {
    return FfiConverterTypeCommitOutput.lift(
      uniffiCaller.rustCallWithError(
        /*liftError:*/ FfiConverterTypeError.lift.bind(FfiConverterTypeError),
        /*caller:*/ (callStatus) => {
          return nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_method_commitbuilder_build(
            uniffiTypeCommitBuilderObjectFactory.clonePointer(this),
            callStatus
          );
        },
        /*liftString:*/ FfiConverterString.lift
      )
    );
  }

  public removeMember(signingIdentity: SigningIdentityInterface): void /*throws*/ {
    uniffiCaller.rustCallWithError(
      /*liftError:*/ FfiConverterTypeError.lift.bind(FfiConverterTypeError),
      /*caller:*/ (callStatus) => {
        nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_method_commitbuilder_remove_member(
          uniffiTypeCommitBuilderObjectFactory.clonePointer(this),
          FfiConverterTypeSigningIdentity.lower(signingIdentity),
          callStatus
        );
      },
      /*liftString:*/ FfiConverterString.lift
    );
  }

  public removeMembers(signingIdentities: Array<SigningIdentityInterface>): void /*throws*/ {
    uniffiCaller.rustCallWithError(
      /*liftError:*/ FfiConverterTypeError.lift.bind(FfiConverterTypeError),
      /*caller:*/ (callStatus) => {
        nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_method_commitbuilder_remove_members(
          uniffiTypeCommitBuilderObjectFactory.clonePointer(this),
          FfiConverterArrayTypeSigningIdentity.lower(signingIdentities),
          callStatus
        );
      },
      /*liftString:*/ FfiConverterString.lift
    );
  }

  /**
   * {@inheritDoc uniffi-bindgen-react-native#UniffiAbstractObject.uniffiDestroy}
   */
  uniffiDestroy(): void {
    const ptr = (this as any)[destructorGuardSymbol];
    if (ptr !== undefined) {
      const pointer = uniffiTypeCommitBuilderObjectFactory.pointer(this);
      uniffiTypeCommitBuilderObjectFactory.freePointer(pointer);
      uniffiTypeCommitBuilderObjectFactory.unbless(ptr);
      delete (this as any)[destructorGuardSymbol];
    }
  }

  static instanceOf(obj: any): obj is CommitBuilder {
    return uniffiTypeCommitBuilderObjectFactory.isConcreteType(obj);
  }
}

const uniffiTypeCommitBuilderObjectFactory: UniffiObjectFactory<CommitBuilderInterface> = (() => {
  /// <reference lib="es2021" />
  const registry =
    typeof FinalizationRegistry !== 'undefined'
      ? new FinalizationRegistry<UnsafeMutableRawPointer>((heldValue: UnsafeMutableRawPointer) => {
          uniffiTypeCommitBuilderObjectFactory.freePointer(heldValue);
        })
      : null;

  return {
    create(pointer: UnsafeMutableRawPointer): CommitBuilderInterface {
      const instance = Object.create(CommitBuilder.prototype);
      instance[pointerLiteralSymbol] = pointer;
      instance[destructorGuardSymbol] = this.bless(pointer);
      instance[uniffiTypeNameSymbol] = 'CommitBuilder';
      return instance;
    },

    bless(p: UnsafeMutableRawPointer): UniffiRustArcPtr {
      const ptr = {
        p, // make sure this object doesn't get optimized away.
        markDestroyed: () => undefined,
      };
      if (registry) {
        registry.register(ptr, p, ptr);
      }
      return ptr;
    },

    unbless(ptr: UniffiRustArcPtr) {
      if (registry) {
        registry.unregister(ptr);
      }
    },

    pointer(obj: CommitBuilderInterface): UnsafeMutableRawPointer {
      if ((obj as any)[destructorGuardSymbol] === undefined) {
        throw new UniffiInternalError.UnexpectedNullPointer();
      }
      return (obj as any)[pointerLiteralSymbol];
    },

    clonePointer(obj: CommitBuilderInterface): UnsafeMutableRawPointer {
      const pointer = this.pointer(obj);
      return uniffiCaller.rustCall(
        /*caller:*/ (callStatus) =>
          nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_clone_commitbuilder(pointer, callStatus),
        /*liftString:*/ FfiConverterString.lift
      );
    },

    freePointer(pointer: UnsafeMutableRawPointer): void {
      uniffiCaller.rustCall(
        /*caller:*/ (callStatus) =>
          nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_free_commitbuilder(pointer, callStatus),
        /*liftString:*/ FfiConverterString.lift
      );
    },

    isConcreteType(obj: any): obj is CommitBuilderInterface {
      return obj[destructorGuardSymbol] && obj[uniffiTypeNameSymbol] === 'CommitBuilder';
    },
  };
})();
// FfiConverter for CommitBuilderInterface
const FfiConverterTypeCommitBuilder = new FfiConverterObject(uniffiTypeCommitBuilderObjectFactory);

/**
 * A [`mls_rs::Extension`] wrapper.
 */
export interface ExtensionInterface {}

/**
 * A [`mls_rs::Extension`] wrapper.
 */
export class Extension extends UniffiAbstractObject implements ExtensionInterface {
  readonly [uniffiTypeNameSymbol] = 'Extension';
  readonly [destructorGuardSymbol]: UniffiRustArcPtr;
  readonly [pointerLiteralSymbol]: UnsafeMutableRawPointer;
  // No primary constructor declared for this class.
  private constructor(pointer: UnsafeMutableRawPointer) {
    super();
    this[pointerLiteralSymbol] = pointer;
    this[destructorGuardSymbol] = uniffiTypeExtensionObjectFactory.bless(pointer);
  }

  /**
   * {@inheritDoc uniffi-bindgen-react-native#UniffiAbstractObject.uniffiDestroy}
   */
  uniffiDestroy(): void {
    const ptr = (this as any)[destructorGuardSymbol];
    if (ptr !== undefined) {
      const pointer = uniffiTypeExtensionObjectFactory.pointer(this);
      uniffiTypeExtensionObjectFactory.freePointer(pointer);
      uniffiTypeExtensionObjectFactory.unbless(ptr);
      delete (this as any)[destructorGuardSymbol];
    }
  }

  static instanceOf(obj: any): obj is Extension {
    return uniffiTypeExtensionObjectFactory.isConcreteType(obj);
  }
}

const uniffiTypeExtensionObjectFactory: UniffiObjectFactory<ExtensionInterface> = (() => {
  /// <reference lib="es2021" />
  const registry =
    typeof FinalizationRegistry !== 'undefined'
      ? new FinalizationRegistry<UnsafeMutableRawPointer>((heldValue: UnsafeMutableRawPointer) => {
          uniffiTypeExtensionObjectFactory.freePointer(heldValue);
        })
      : null;

  return {
    create(pointer: UnsafeMutableRawPointer): ExtensionInterface {
      const instance = Object.create(Extension.prototype);
      instance[pointerLiteralSymbol] = pointer;
      instance[destructorGuardSymbol] = this.bless(pointer);
      instance[uniffiTypeNameSymbol] = 'Extension';
      return instance;
    },

    bless(p: UnsafeMutableRawPointer): UniffiRustArcPtr {
      const ptr = {
        p, // make sure this object doesn't get optimized away.
        markDestroyed: () => undefined,
      };
      if (registry) {
        registry.register(ptr, p, ptr);
      }
      return ptr;
    },

    unbless(ptr: UniffiRustArcPtr) {
      if (registry) {
        registry.unregister(ptr);
      }
    },

    pointer(obj: ExtensionInterface): UnsafeMutableRawPointer {
      if ((obj as any)[destructorGuardSymbol] === undefined) {
        throw new UniffiInternalError.UnexpectedNullPointer();
      }
      return (obj as any)[pointerLiteralSymbol];
    },

    clonePointer(obj: ExtensionInterface): UnsafeMutableRawPointer {
      const pointer = this.pointer(obj);
      return uniffiCaller.rustCall(
        /*caller:*/ (callStatus) =>
          nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_clone_extension(pointer, callStatus),
        /*liftString:*/ FfiConverterString.lift
      );
    },

    freePointer(pointer: UnsafeMutableRawPointer): void {
      uniffiCaller.rustCall(
        /*caller:*/ (callStatus) =>
          nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_free_extension(pointer, callStatus),
        /*liftString:*/ FfiConverterString.lift
      );
    },

    isConcreteType(obj: any): obj is ExtensionInterface {
      return obj[destructorGuardSymbol] && obj[uniffiTypeNameSymbol] === 'Extension';
    },
  };
})();
// FfiConverter for ExtensionInterface
const FfiConverterTypeExtension = new FfiConverterObject(uniffiTypeExtensionObjectFactory);

/**
 * A [`mls_rs::ExtensionList`] wrapper.
 */
export interface ExtensionListInterface {}

/**
 * A [`mls_rs::ExtensionList`] wrapper.
 */
export class ExtensionList extends UniffiAbstractObject implements ExtensionListInterface {
  readonly [uniffiTypeNameSymbol] = 'ExtensionList';
  readonly [destructorGuardSymbol]: UniffiRustArcPtr;
  readonly [pointerLiteralSymbol]: UnsafeMutableRawPointer;
  // No primary constructor declared for this class.
  private constructor(pointer: UnsafeMutableRawPointer) {
    super();
    this[pointerLiteralSymbol] = pointer;
    this[destructorGuardSymbol] = uniffiTypeExtensionListObjectFactory.bless(pointer);
  }

  /**
   * {@inheritDoc uniffi-bindgen-react-native#UniffiAbstractObject.uniffiDestroy}
   */
  uniffiDestroy(): void {
    const ptr = (this as any)[destructorGuardSymbol];
    if (ptr !== undefined) {
      const pointer = uniffiTypeExtensionListObjectFactory.pointer(this);
      uniffiTypeExtensionListObjectFactory.freePointer(pointer);
      uniffiTypeExtensionListObjectFactory.unbless(ptr);
      delete (this as any)[destructorGuardSymbol];
    }
  }

  static instanceOf(obj: any): obj is ExtensionList {
    return uniffiTypeExtensionListObjectFactory.isConcreteType(obj);
  }
}

const uniffiTypeExtensionListObjectFactory: UniffiObjectFactory<ExtensionListInterface> = (() => {
  /// <reference lib="es2021" />
  const registry =
    typeof FinalizationRegistry !== 'undefined'
      ? new FinalizationRegistry<UnsafeMutableRawPointer>((heldValue: UnsafeMutableRawPointer) => {
          uniffiTypeExtensionListObjectFactory.freePointer(heldValue);
        })
      : null;

  return {
    create(pointer: UnsafeMutableRawPointer): ExtensionListInterface {
      const instance = Object.create(ExtensionList.prototype);
      instance[pointerLiteralSymbol] = pointer;
      instance[destructorGuardSymbol] = this.bless(pointer);
      instance[uniffiTypeNameSymbol] = 'ExtensionList';
      return instance;
    },

    bless(p: UnsafeMutableRawPointer): UniffiRustArcPtr {
      const ptr = {
        p, // make sure this object doesn't get optimized away.
        markDestroyed: () => undefined,
      };
      if (registry) {
        registry.register(ptr, p, ptr);
      }
      return ptr;
    },

    unbless(ptr: UniffiRustArcPtr) {
      if (registry) {
        registry.unregister(ptr);
      }
    },

    pointer(obj: ExtensionListInterface): UnsafeMutableRawPointer {
      if ((obj as any)[destructorGuardSymbol] === undefined) {
        throw new UniffiInternalError.UnexpectedNullPointer();
      }
      return (obj as any)[pointerLiteralSymbol];
    },

    clonePointer(obj: ExtensionListInterface): UnsafeMutableRawPointer {
      const pointer = this.pointer(obj);
      return uniffiCaller.rustCall(
        /*caller:*/ (callStatus) =>
          nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_clone_extensionlist(pointer, callStatus),
        /*liftString:*/ FfiConverterString.lift
      );
    },

    freePointer(pointer: UnsafeMutableRawPointer): void {
      uniffiCaller.rustCall(
        /*caller:*/ (callStatus) =>
          nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_free_extensionlist(pointer, callStatus),
        /*liftString:*/ FfiConverterString.lift
      );
    },

    isConcreteType(obj: any): obj is ExtensionListInterface {
      return obj[destructorGuardSymbol] && obj[uniffiTypeNameSymbol] === 'ExtensionList';
    },
  };
})();
// FfiConverter for ExtensionListInterface
const FfiConverterTypeExtensionList = new FfiConverterObject(uniffiTypeExtensionListObjectFactory);

/**
 * An MLS end-to-end encrypted group.
 *
 * The group is used to send and process incoming messages and to
 * add/remove users.
 *
 * See [`mls_rs::Group`] for details.
 */
export interface GroupInterface {
  /**
   * Commit the addition of one or more members.
   *
   * The members are representated by key packages. The result is
   * the welcome messages to send to the new members.
   *
   * See [`mls_rs::group::CommitBuilder::add_member`] for details.
   */
  addMembers(keyPackages: Array<MessageInterface>): /*throws*/ CommitOutput;
  /**
   * Clear the currently pending commit.
   *
   * This is useful when a commit was created but should be discarded
   * without applying it.
   */
  clearPendingCommit(): void;
  /**
   * Perform a commit of received proposals (or an empty commit).
   *
   * TODO: ensure `path_required` is always set in
   * [`MlsRules::commit_options`](`mls_rs::MlsRules::commit_options`).
   *
   * Returns the resulting commit message. See
   * [`mls_rs::Group::commit`] for details.
   */
  commit(): /*throws*/ CommitOutput;
  /**
   * Create a [`CommitBuilder`] for this group.
   *
   * The builder can be used to queue multiple operations (add and
   * remove members) and commit them in a single commit.
   */
  commitBuilder(): CommitBuilderInterface;
  /**
   * Returns the current epoch of the group.
   */
  currentEpoch(): /*u64*/ bigint;
  /**
   * Encrypt an application message using the current group state.
   *
   * An application message is an application-specific payload,
   * e.g., an UTF-8 encoded text message in a chat app. The
   * encoding is not determined by MLS and applications will have
   * to implement their own mechanism for how to agree on the
   * content encoding.
   *
   * The other group members will find the message in
   * [`ReceivedMessage::ApplicationMessage`] after calling
   * [`Group::process_incoming_message`].
   */
  encryptApplicationMessage(message: ArrayBuffer): /*throws*/ MessageInterface;
  /**
   * Export the current epoch's ratchet tree in serialized format.
   *
   * This function is used to provide the current group tree to new
   * members when `use_ratchet_tree_extension` is set to false in
   * `ClientConfig`.
   */
  exportTree(): /*throws*/ RatchetTree;
  /**
   * Returns the group ID.
   */
  groupId(): ArrayBuffer;
  /**
   * Returns the current group members with inspectable identity metadata.
   */
  members(): /*throws*/ Array<GroupMemberInfo>;
  /**
   * Process an inbound message for this group.
   */
  processIncomingMessage(message: MessageInterface): /*throws*/ ReceivedMessage;
  /**
   * Propose to add one or more members to this group.
   *
   * The members are representated by key packages. The result is
   * the proposal messages to send to the group.
   *
   * See [`mls_rs::Group::propose_add`] for details.
   */
  proposeAddMembers(keyPackages: Array<MessageInterface>): /*throws*/ Array<MessageInterface>;
  /**
   * Propose to remove one or more members from this group.
   *
   * The members are representated by their signing identities. The
   * result is the proposal messages to send to the group.
   *
   * See [`mls_rs::group::Group::propose_remove`] for details.
   */
  proposeRemoveMembers(
    signingIdentities: Array<SigningIdentityInterface>
  ): /*throws*/ Array<MessageInterface>;
  /**
   * Propose and commit the removal of one or more members.
   *
   * The members are representated by their signing identities.
   *
   * See [`mls_rs::group::CommitBuilder::remove_member`] for details.
   */
  removeMembers(signingIdentities: Array<SigningIdentityInterface>): /*throws*/ CommitOutput;
  /**
   * Write the current state of the group to storage defined by
   * [`ClientConfig::group_state_storage`]
   */
  writeToStorage(): /*throws*/ void;
}

/**
 * An MLS end-to-end encrypted group.
 *
 * The group is used to send and process incoming messages and to
 * add/remove users.
 *
 * See [`mls_rs::Group`] for details.
 */
export class Group extends UniffiAbstractObject implements GroupInterface {
  readonly [uniffiTypeNameSymbol] = 'Group';
  readonly [destructorGuardSymbol]: UniffiRustArcPtr;
  readonly [pointerLiteralSymbol]: UnsafeMutableRawPointer;
  // No primary constructor declared for this class.
  private constructor(pointer: UnsafeMutableRawPointer) {
    super();
    this[pointerLiteralSymbol] = pointer;
    this[destructorGuardSymbol] = uniffiTypeGroupObjectFactory.bless(pointer);
  }

  /**
   * Commit the addition of one or more members.
   *
   * The members are representated by key packages. The result is
   * the welcome messages to send to the new members.
   *
   * See [`mls_rs::group::CommitBuilder::add_member`] for details.
   */
  public addMembers(keyPackages: Array<MessageInterface>): CommitOutput /*throws*/ {
    return FfiConverterTypeCommitOutput.lift(
      uniffiCaller.rustCallWithError(
        /*liftError:*/ FfiConverterTypeError.lift.bind(FfiConverterTypeError),
        /*caller:*/ (callStatus) => {
          return nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_method_group_add_members(
            uniffiTypeGroupObjectFactory.clonePointer(this),
            FfiConverterArrayTypeMessage.lower(keyPackages),
            callStatus
          );
        },
        /*liftString:*/ FfiConverterString.lift
      )
    );
  }

  /**
   * Clear the currently pending commit.
   *
   * This is useful when a commit was created but should be discarded
   * without applying it.
   */
  public clearPendingCommit(): void {
    uniffiCaller.rustCall(
      /*caller:*/ (callStatus) => {
        nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_method_group_clear_pending_commit(
          uniffiTypeGroupObjectFactory.clonePointer(this),
          callStatus
        );
      },
      /*liftString:*/ FfiConverterString.lift
    );
  }

  /**
   * Perform a commit of received proposals (or an empty commit).
   *
   * TODO: ensure `path_required` is always set in
   * [`MlsRules::commit_options`](`mls_rs::MlsRules::commit_options`).
   *
   * Returns the resulting commit message. See
   * [`mls_rs::Group::commit`] for details.
   */
  public commit(): CommitOutput /*throws*/ {
    return FfiConverterTypeCommitOutput.lift(
      uniffiCaller.rustCallWithError(
        /*liftError:*/ FfiConverterTypeError.lift.bind(FfiConverterTypeError),
        /*caller:*/ (callStatus) => {
          return nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_method_group_commit(
            uniffiTypeGroupObjectFactory.clonePointer(this),
            callStatus
          );
        },
        /*liftString:*/ FfiConverterString.lift
      )
    );
  }

  /**
   * Create a [`CommitBuilder`] for this group.
   *
   * The builder can be used to queue multiple operations (add and
   * remove members) and commit them in a single commit.
   */
  public commitBuilder(): CommitBuilderInterface {
    return FfiConverterTypeCommitBuilder.lift(
      uniffiCaller.rustCall(
        /*caller:*/ (callStatus) => {
          return nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_method_group_commit_builder(
            uniffiTypeGroupObjectFactory.clonePointer(this),
            callStatus
          );
        },
        /*liftString:*/ FfiConverterString.lift
      )
    );
  }

  /**
   * Returns the current epoch of the group.
   */
  public currentEpoch(): /*u64*/ bigint {
    return FfiConverterUInt64.lift(
      uniffiCaller.rustCall(
        /*caller:*/ (callStatus) => {
          return nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_method_group_current_epoch(
            uniffiTypeGroupObjectFactory.clonePointer(this),
            callStatus
          );
        },
        /*liftString:*/ FfiConverterString.lift
      )
    );
  }

  /**
   * Encrypt an application message using the current group state.
   *
   * An application message is an application-specific payload,
   * e.g., an UTF-8 encoded text message in a chat app. The
   * encoding is not determined by MLS and applications will have
   * to implement their own mechanism for how to agree on the
   * content encoding.
   *
   * The other group members will find the message in
   * [`ReceivedMessage::ApplicationMessage`] after calling
   * [`Group::process_incoming_message`].
   */
  public encryptApplicationMessage(message: ArrayBuffer): MessageInterface /*throws*/ {
    return FfiConverterTypeMessage.lift(
      uniffiCaller.rustCallWithError(
        /*liftError:*/ FfiConverterTypeError.lift.bind(FfiConverterTypeError),
        /*caller:*/ (callStatus) => {
          return nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_method_group_encrypt_application_message(
            uniffiTypeGroupObjectFactory.clonePointer(this),
            FfiConverterArrayBuffer.lower(message),
            callStatus
          );
        },
        /*liftString:*/ FfiConverterString.lift
      )
    );
  }

  /**
   * Export the current epoch's ratchet tree in serialized format.
   *
   * This function is used to provide the current group tree to new
   * members when `use_ratchet_tree_extension` is set to false in
   * `ClientConfig`.
   */
  public exportTree(): RatchetTree /*throws*/ {
    return FfiConverterTypeRatchetTree.lift(
      uniffiCaller.rustCallWithError(
        /*liftError:*/ FfiConverterTypeError.lift.bind(FfiConverterTypeError),
        /*caller:*/ (callStatus) => {
          return nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_method_group_export_tree(
            uniffiTypeGroupObjectFactory.clonePointer(this),
            callStatus
          );
        },
        /*liftString:*/ FfiConverterString.lift
      )
    );
  }

  /**
   * Returns the group ID.
   */
  public groupId(): ArrayBuffer {
    return FfiConverterArrayBuffer.lift(
      uniffiCaller.rustCall(
        /*caller:*/ (callStatus) => {
          return nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_method_group_group_id(
            uniffiTypeGroupObjectFactory.clonePointer(this),
            callStatus
          );
        },
        /*liftString:*/ FfiConverterString.lift
      )
    );
  }

  /**
   * Returns the current group members with inspectable identity metadata.
   */
  public members(): Array<GroupMemberInfo> /*throws*/ {
    return FfiConverterArrayTypeGroupMemberInfo.lift(
      uniffiCaller.rustCallWithError(
        /*liftError:*/ FfiConverterTypeError.lift.bind(FfiConverterTypeError),
        /*caller:*/ (callStatus) => {
          return nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_method_group_members(
            uniffiTypeGroupObjectFactory.clonePointer(this),
            callStatus
          );
        },
        /*liftString:*/ FfiConverterString.lift
      )
    );
  }

  /**
   * Process an inbound message for this group.
   */
  public processIncomingMessage(message: MessageInterface): ReceivedMessage /*throws*/ {
    return FfiConverterTypeReceivedMessage.lift(
      uniffiCaller.rustCallWithError(
        /*liftError:*/ FfiConverterTypeError.lift.bind(FfiConverterTypeError),
        /*caller:*/ (callStatus) => {
          return nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_method_group_process_incoming_message(
            uniffiTypeGroupObjectFactory.clonePointer(this),
            FfiConverterTypeMessage.lower(message),
            callStatus
          );
        },
        /*liftString:*/ FfiConverterString.lift
      )
    );
  }

  /**
   * Propose to add one or more members to this group.
   *
   * The members are representated by key packages. The result is
   * the proposal messages to send to the group.
   *
   * See [`mls_rs::Group::propose_add`] for details.
   */
  public proposeAddMembers(
    keyPackages: Array<MessageInterface>
  ): Array<MessageInterface> /*throws*/ {
    return FfiConverterArrayTypeMessage.lift(
      uniffiCaller.rustCallWithError(
        /*liftError:*/ FfiConverterTypeError.lift.bind(FfiConverterTypeError),
        /*caller:*/ (callStatus) => {
          return nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_method_group_propose_add_members(
            uniffiTypeGroupObjectFactory.clonePointer(this),
            FfiConverterArrayTypeMessage.lower(keyPackages),
            callStatus
          );
        },
        /*liftString:*/ FfiConverterString.lift
      )
    );
  }

  /**
   * Propose to remove one or more members from this group.
   *
   * The members are representated by their signing identities. The
   * result is the proposal messages to send to the group.
   *
   * See [`mls_rs::group::Group::propose_remove`] for details.
   */
  public proposeRemoveMembers(
    signingIdentities: Array<SigningIdentityInterface>
  ): Array<MessageInterface> /*throws*/ {
    return FfiConverterArrayTypeMessage.lift(
      uniffiCaller.rustCallWithError(
        /*liftError:*/ FfiConverterTypeError.lift.bind(FfiConverterTypeError),
        /*caller:*/ (callStatus) => {
          return nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_method_group_propose_remove_members(
            uniffiTypeGroupObjectFactory.clonePointer(this),
            FfiConverterArrayTypeSigningIdentity.lower(signingIdentities),
            callStatus
          );
        },
        /*liftString:*/ FfiConverterString.lift
      )
    );
  }

  /**
   * Propose and commit the removal of one or more members.
   *
   * The members are representated by their signing identities.
   *
   * See [`mls_rs::group::CommitBuilder::remove_member`] for details.
   */
  public removeMembers(
    signingIdentities: Array<SigningIdentityInterface>
  ): CommitOutput /*throws*/ {
    return FfiConverterTypeCommitOutput.lift(
      uniffiCaller.rustCallWithError(
        /*liftError:*/ FfiConverterTypeError.lift.bind(FfiConverterTypeError),
        /*caller:*/ (callStatus) => {
          return nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_method_group_remove_members(
            uniffiTypeGroupObjectFactory.clonePointer(this),
            FfiConverterArrayTypeSigningIdentity.lower(signingIdentities),
            callStatus
          );
        },
        /*liftString:*/ FfiConverterString.lift
      )
    );
  }

  /**
   * Write the current state of the group to storage defined by
   * [`ClientConfig::group_state_storage`]
   */
  public writeToStorage(): void /*throws*/ {
    uniffiCaller.rustCallWithError(
      /*liftError:*/ FfiConverterTypeError.lift.bind(FfiConverterTypeError),
      /*caller:*/ (callStatus) => {
        nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_method_group_write_to_storage(
          uniffiTypeGroupObjectFactory.clonePointer(this),
          callStatus
        );
      },
      /*liftString:*/ FfiConverterString.lift
    );
  }

  /**
   * {@inheritDoc uniffi-bindgen-react-native#UniffiAbstractObject.uniffiDestroy}
   */
  uniffiDestroy(): void {
    const ptr = (this as any)[destructorGuardSymbol];
    if (ptr !== undefined) {
      const pointer = uniffiTypeGroupObjectFactory.pointer(this);
      uniffiTypeGroupObjectFactory.freePointer(pointer);
      uniffiTypeGroupObjectFactory.unbless(ptr);
      delete (this as any)[destructorGuardSymbol];
    }
  }

  static instanceOf(obj: any): obj is Group {
    return uniffiTypeGroupObjectFactory.isConcreteType(obj);
  }
}

const uniffiTypeGroupObjectFactory: UniffiObjectFactory<GroupInterface> = (() => {
  /// <reference lib="es2021" />
  const registry =
    typeof FinalizationRegistry !== 'undefined'
      ? new FinalizationRegistry<UnsafeMutableRawPointer>((heldValue: UnsafeMutableRawPointer) => {
          uniffiTypeGroupObjectFactory.freePointer(heldValue);
        })
      : null;

  return {
    create(pointer: UnsafeMutableRawPointer): GroupInterface {
      const instance = Object.create(Group.prototype);
      instance[pointerLiteralSymbol] = pointer;
      instance[destructorGuardSymbol] = this.bless(pointer);
      instance[uniffiTypeNameSymbol] = 'Group';
      return instance;
    },

    bless(p: UnsafeMutableRawPointer): UniffiRustArcPtr {
      const ptr = {
        p, // make sure this object doesn't get optimized away.
        markDestroyed: () => undefined,
      };
      if (registry) {
        registry.register(ptr, p, ptr);
      }
      return ptr;
    },

    unbless(ptr: UniffiRustArcPtr) {
      if (registry) {
        registry.unregister(ptr);
      }
    },

    pointer(obj: GroupInterface): UnsafeMutableRawPointer {
      if ((obj as any)[destructorGuardSymbol] === undefined) {
        throw new UniffiInternalError.UnexpectedNullPointer();
      }
      return (obj as any)[pointerLiteralSymbol];
    },

    clonePointer(obj: GroupInterface): UnsafeMutableRawPointer {
      const pointer = this.pointer(obj);
      return uniffiCaller.rustCall(
        /*caller:*/ (callStatus) =>
          nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_clone_group(pointer, callStatus),
        /*liftString:*/ FfiConverterString.lift
      );
    },

    freePointer(pointer: UnsafeMutableRawPointer): void {
      uniffiCaller.rustCall(
        /*caller:*/ (callStatus) =>
          nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_free_group(pointer, callStatus),
        /*liftString:*/ FfiConverterString.lift
      );
    },

    isConcreteType(obj: any): obj is GroupInterface {
      return obj[destructorGuardSymbol] && obj[uniffiTypeNameSymbol] === 'Group';
    },
  };
})();
// FfiConverter for GroupInterface
const FfiConverterTypeGroup = new FfiConverterObject(uniffiTypeGroupObjectFactory);

export interface GroupStateStorage {
  state(groupId: ArrayBuffer): /*throws*/ ArrayBuffer | undefined;
  epoch(groupId: ArrayBuffer, epochId: /*u64*/ bigint): /*throws*/ ArrayBuffer | undefined;
  write(
    groupId: ArrayBuffer,
    groupState: ArrayBuffer,
    epochInserts: Array<EpochRecord>,
    epochUpdates: Array<EpochRecord>
  ): /*throws*/ void;
  maxEpochId(groupId: ArrayBuffer): /*throws*/ /*u64*/ bigint | undefined;
}

export class GroupStateStorageImpl extends UniffiAbstractObject implements GroupStateStorage {
  readonly [uniffiTypeNameSymbol] = 'GroupStateStorageImpl';
  readonly [destructorGuardSymbol]: UniffiRustArcPtr;
  readonly [pointerLiteralSymbol]: UnsafeMutableRawPointer;
  // No primary constructor declared for this class.
  private constructor(pointer: UnsafeMutableRawPointer) {
    super();
    this[pointerLiteralSymbol] = pointer;
    this[destructorGuardSymbol] = uniffiTypeGroupStateStorageImplObjectFactory.bless(pointer);
  }

  public state(groupId: ArrayBuffer): ArrayBuffer | undefined /*throws*/ {
    return FfiConverterOptionalArrayBuffer.lift(
      uniffiCaller.rustCallWithError(
        /*liftError:*/ FfiConverterTypeError.lift.bind(FfiConverterTypeError),
        /*caller:*/ (callStatus) => {
          return nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_method_groupstatestorage_state(
            uniffiTypeGroupStateStorageImplObjectFactory.clonePointer(this),
            FfiConverterArrayBuffer.lower(groupId),
            callStatus
          );
        },
        /*liftString:*/ FfiConverterString.lift
      )
    );
  }

  public epoch(groupId: ArrayBuffer, epochId: /*u64*/ bigint): ArrayBuffer | undefined /*throws*/ {
    return FfiConverterOptionalArrayBuffer.lift(
      uniffiCaller.rustCallWithError(
        /*liftError:*/ FfiConverterTypeError.lift.bind(FfiConverterTypeError),
        /*caller:*/ (callStatus) => {
          return nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_method_groupstatestorage_epoch(
            uniffiTypeGroupStateStorageImplObjectFactory.clonePointer(this),
            FfiConverterArrayBuffer.lower(groupId),
            FfiConverterUInt64.lower(epochId),
            callStatus
          );
        },
        /*liftString:*/ FfiConverterString.lift
      )
    );
  }

  public write(
    groupId: ArrayBuffer,
    groupState: ArrayBuffer,
    epochInserts: Array<EpochRecord>,
    epochUpdates: Array<EpochRecord>
  ): void /*throws*/ {
    uniffiCaller.rustCallWithError(
      /*liftError:*/ FfiConverterTypeError.lift.bind(FfiConverterTypeError),
      /*caller:*/ (callStatus) => {
        nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_method_groupstatestorage_write(
          uniffiTypeGroupStateStorageImplObjectFactory.clonePointer(this),
          FfiConverterArrayBuffer.lower(groupId),
          FfiConverterArrayBuffer.lower(groupState),
          FfiConverterArrayTypeEpochRecord.lower(epochInserts),
          FfiConverterArrayTypeEpochRecord.lower(epochUpdates),
          callStatus
        );
      },
      /*liftString:*/ FfiConverterString.lift
    );
  }

  public maxEpochId(groupId: ArrayBuffer): /*u64*/ bigint | undefined /*throws*/ {
    return FfiConverterOptionalUInt64.lift(
      uniffiCaller.rustCallWithError(
        /*liftError:*/ FfiConverterTypeError.lift.bind(FfiConverterTypeError),
        /*caller:*/ (callStatus) => {
          return nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_method_groupstatestorage_max_epoch_id(
            uniffiTypeGroupStateStorageImplObjectFactory.clonePointer(this),
            FfiConverterArrayBuffer.lower(groupId),
            callStatus
          );
        },
        /*liftString:*/ FfiConverterString.lift
      )
    );
  }

  /**
   * {@inheritDoc uniffi-bindgen-react-native#UniffiAbstractObject.uniffiDestroy}
   */
  uniffiDestroy(): void {
    const ptr = (this as any)[destructorGuardSymbol];
    if (ptr !== undefined) {
      const pointer = uniffiTypeGroupStateStorageImplObjectFactory.pointer(this);
      uniffiTypeGroupStateStorageImplObjectFactory.freePointer(pointer);
      uniffiTypeGroupStateStorageImplObjectFactory.unbless(ptr);
      delete (this as any)[destructorGuardSymbol];
    }
  }

  static instanceOf(obj: any): obj is GroupStateStorageImpl {
    return uniffiTypeGroupStateStorageImplObjectFactory.isConcreteType(obj);
  }
}

const uniffiTypeGroupStateStorageImplObjectFactory: UniffiObjectFactory<GroupStateStorage> =
  (() => {
    /// <reference lib="es2021" />
    const registry =
      typeof FinalizationRegistry !== 'undefined'
        ? new FinalizationRegistry<UnsafeMutableRawPointer>(
            (heldValue: UnsafeMutableRawPointer) => {
              uniffiTypeGroupStateStorageImplObjectFactory.freePointer(heldValue);
            }
          )
        : null;

    return {
      create(pointer: UnsafeMutableRawPointer): GroupStateStorage {
        const instance = Object.create(GroupStateStorageImpl.prototype);
        instance[pointerLiteralSymbol] = pointer;
        instance[destructorGuardSymbol] = this.bless(pointer);
        instance[uniffiTypeNameSymbol] = 'GroupStateStorageImpl';
        return instance;
      },

      bless(p: UnsafeMutableRawPointer): UniffiRustArcPtr {
        const ptr = {
          p, // make sure this object doesn't get optimized away.
          markDestroyed: () => undefined,
        };
        if (registry) {
          registry.register(ptr, p, ptr);
        }
        return ptr;
      },

      unbless(ptr: UniffiRustArcPtr) {
        if (registry) {
          registry.unregister(ptr);
        }
      },

      pointer(obj: GroupStateStorage): UnsafeMutableRawPointer {
        if ((obj as any)[destructorGuardSymbol] === undefined) {
          throw new UniffiInternalError.UnexpectedNullPointer();
        }
        return (obj as any)[pointerLiteralSymbol];
      },

      clonePointer(obj: GroupStateStorage): UnsafeMutableRawPointer {
        const pointer = this.pointer(obj);
        return uniffiCaller.rustCall(
          /*caller:*/ (callStatus) =>
            nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_clone_groupstatestorage(
              pointer,
              callStatus
            ),
          /*liftString:*/ FfiConverterString.lift
        );
      },

      freePointer(pointer: UnsafeMutableRawPointer): void {
        uniffiCaller.rustCall(
          /*caller:*/ (callStatus) =>
            nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_free_groupstatestorage(pointer, callStatus),
          /*liftString:*/ FfiConverterString.lift
        );
      },

      isConcreteType(obj: any): obj is GroupStateStorage {
        return obj[destructorGuardSymbol] && obj[uniffiTypeNameSymbol] === 'GroupStateStorageImpl';
      },
    };
  })();
// FfiConverter for GroupStateStorage
const FfiConverterTypeGroupStateStorage = new FfiConverterObjectWithCallbacks(
  uniffiTypeGroupStateStorageImplObjectFactory
);

// Add a vtavble for the callbacks that go in GroupStateStorage.

// Put the implementation in a struct so we don't pollute the top-level namespace
const uniffiCallbackInterfaceGroupStateStorage: { vtable: any; register: () => void } = {
  // Create the VTable using a series of closures.
  // ts automatically converts these into C callback functions.
  vtable: {
    state: (uniffiHandle: bigint, groupId: Uint8Array) => {
      const uniffiMakeCall = (): ArrayBuffer | undefined => {
        const jsCallback = FfiConverterTypeGroupStateStorage.lift(uniffiHandle);
        return jsCallback.state(FfiConverterArrayBuffer.lift(groupId));
      };
      const uniffiResult = UniffiResult.ready<Uint8Array>();
      const uniffiHandleSuccess = (obj: any) => {
        UniffiResult.writeSuccess(uniffiResult, FfiConverterOptionalArrayBuffer.lower(obj));
      };
      const uniffiHandleError = (code: number, errBuf: UniffiByteArray) => {
        UniffiResult.writeError(uniffiResult, code, errBuf);
      };
      uniffiTraitInterfaceCallWithError(
        /*makeCall:*/ uniffiMakeCall,
        /*handleSuccess:*/ uniffiHandleSuccess,
        /*handleError:*/ uniffiHandleError,
        /*isErrorType:*/ Exception.instanceOf,
        /*lowerError:*/ FfiConverterTypeError.lower.bind(FfiConverterTypeError),
        /*lowerString:*/ FfiConverterString.lower
      );
      return uniffiResult;
    },
    epoch: (uniffiHandle: bigint, groupId: Uint8Array, epochId: bigint) => {
      const uniffiMakeCall = (): ArrayBuffer | undefined => {
        const jsCallback = FfiConverterTypeGroupStateStorage.lift(uniffiHandle);
        return jsCallback.epoch(
          FfiConverterArrayBuffer.lift(groupId),
          FfiConverterUInt64.lift(epochId)
        );
      };
      const uniffiResult = UniffiResult.ready<Uint8Array>();
      const uniffiHandleSuccess = (obj: any) => {
        UniffiResult.writeSuccess(uniffiResult, FfiConverterOptionalArrayBuffer.lower(obj));
      };
      const uniffiHandleError = (code: number, errBuf: UniffiByteArray) => {
        UniffiResult.writeError(uniffiResult, code, errBuf);
      };
      uniffiTraitInterfaceCallWithError(
        /*makeCall:*/ uniffiMakeCall,
        /*handleSuccess:*/ uniffiHandleSuccess,
        /*handleError:*/ uniffiHandleError,
        /*isErrorType:*/ Exception.instanceOf,
        /*lowerError:*/ FfiConverterTypeError.lower.bind(FfiConverterTypeError),
        /*lowerString:*/ FfiConverterString.lower
      );
      return uniffiResult;
    },
    write: (
      uniffiHandle: bigint,
      groupId: Uint8Array,
      groupState: Uint8Array,
      epochInserts: Uint8Array,
      epochUpdates: Uint8Array
    ) => {
      const uniffiMakeCall = (): void => {
        const jsCallback = FfiConverterTypeGroupStateStorage.lift(uniffiHandle);
        return jsCallback.write(
          FfiConverterArrayBuffer.lift(groupId),
          FfiConverterArrayBuffer.lift(groupState),
          FfiConverterArrayTypeEpochRecord.lift(epochInserts),
          FfiConverterArrayTypeEpochRecord.lift(epochUpdates)
        );
      };
      const uniffiResult = UniffiResult.ready<void>();
      const uniffiHandleSuccess = (obj: any) => {};
      const uniffiHandleError = (code: number, errBuf: UniffiByteArray) => {
        UniffiResult.writeError(uniffiResult, code, errBuf);
      };
      uniffiTraitInterfaceCallWithError(
        /*makeCall:*/ uniffiMakeCall,
        /*handleSuccess:*/ uniffiHandleSuccess,
        /*handleError:*/ uniffiHandleError,
        /*isErrorType:*/ Exception.instanceOf,
        /*lowerError:*/ FfiConverterTypeError.lower.bind(FfiConverterTypeError),
        /*lowerString:*/ FfiConverterString.lower
      );
      return uniffiResult;
    },
    maxEpochId: (uniffiHandle: bigint, groupId: Uint8Array) => {
      const uniffiMakeCall = (): /*u64*/ bigint | undefined => {
        const jsCallback = FfiConverterTypeGroupStateStorage.lift(uniffiHandle);
        return jsCallback.maxEpochId(FfiConverterArrayBuffer.lift(groupId));
      };
      const uniffiResult = UniffiResult.ready<Uint8Array>();
      const uniffiHandleSuccess = (obj: any) => {
        UniffiResult.writeSuccess(uniffiResult, FfiConverterOptionalUInt64.lower(obj));
      };
      const uniffiHandleError = (code: number, errBuf: UniffiByteArray) => {
        UniffiResult.writeError(uniffiResult, code, errBuf);
      };
      uniffiTraitInterfaceCallWithError(
        /*makeCall:*/ uniffiMakeCall,
        /*handleSuccess:*/ uniffiHandleSuccess,
        /*handleError:*/ uniffiHandleError,
        /*isErrorType:*/ Exception.instanceOf,
        /*lowerError:*/ FfiConverterTypeError.lower.bind(FfiConverterTypeError),
        /*lowerString:*/ FfiConverterString.lower
      );
      return uniffiResult;
    },
    uniffiFree: (uniffiHandle: UniffiHandle): void => {
      // GroupStateStorage: this will throw a stale handle error if the handle isn't found.
      FfiConverterTypeGroupStateStorage.drop(uniffiHandle);
    },
  },
  register: () => {
    nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_init_callback_vtable_groupstatestorage(
      uniffiCallbackInterfaceGroupStateStorage.vtable
    );
  },
};

/**
 * Storage for key package secrets.
 *
 * Values are MLS-encoded [`KeyPackageData`] blobs.
 */
export interface KeyPackageStorage {
  insert(id: ArrayBuffer, data: ArrayBuffer): /*throws*/ void;
  get(id: ArrayBuffer): /*throws*/ ArrayBuffer | undefined;
  delete(id: ArrayBuffer): /*throws*/ void;
}

/**
 * Storage for key package secrets.
 *
 * Values are MLS-encoded [`KeyPackageData`] blobs.
 */
export class KeyPackageStorageImpl extends UniffiAbstractObject implements KeyPackageStorage {
  readonly [uniffiTypeNameSymbol] = 'KeyPackageStorageImpl';
  readonly [destructorGuardSymbol]: UniffiRustArcPtr;
  readonly [pointerLiteralSymbol]: UnsafeMutableRawPointer;
  // No primary constructor declared for this class.
  private constructor(pointer: UnsafeMutableRawPointer) {
    super();
    this[pointerLiteralSymbol] = pointer;
    this[destructorGuardSymbol] = uniffiTypeKeyPackageStorageImplObjectFactory.bless(pointer);
  }

  public insert(id: ArrayBuffer, data: ArrayBuffer): void /*throws*/ {
    uniffiCaller.rustCallWithError(
      /*liftError:*/ FfiConverterTypeError.lift.bind(FfiConverterTypeError),
      /*caller:*/ (callStatus) => {
        nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_method_keypackagestorage_insert(
          uniffiTypeKeyPackageStorageImplObjectFactory.clonePointer(this),
          FfiConverterArrayBuffer.lower(id),
          FfiConverterArrayBuffer.lower(data),
          callStatus
        );
      },
      /*liftString:*/ FfiConverterString.lift
    );
  }

  public get(id: ArrayBuffer): ArrayBuffer | undefined /*throws*/ {
    return FfiConverterOptionalArrayBuffer.lift(
      uniffiCaller.rustCallWithError(
        /*liftError:*/ FfiConverterTypeError.lift.bind(FfiConverterTypeError),
        /*caller:*/ (callStatus) => {
          return nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_method_keypackagestorage_get(
            uniffiTypeKeyPackageStorageImplObjectFactory.clonePointer(this),
            FfiConverterArrayBuffer.lower(id),
            callStatus
          );
        },
        /*liftString:*/ FfiConverterString.lift
      )
    );
  }

  public delete(id: ArrayBuffer): void /*throws*/ {
    uniffiCaller.rustCallWithError(
      /*liftError:*/ FfiConverterTypeError.lift.bind(FfiConverterTypeError),
      /*caller:*/ (callStatus) => {
        nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_method_keypackagestorage_delete(
          uniffiTypeKeyPackageStorageImplObjectFactory.clonePointer(this),
          FfiConverterArrayBuffer.lower(id),
          callStatus
        );
      },
      /*liftString:*/ FfiConverterString.lift
    );
  }

  /**
   * {@inheritDoc uniffi-bindgen-react-native#UniffiAbstractObject.uniffiDestroy}
   */
  uniffiDestroy(): void {
    const ptr = (this as any)[destructorGuardSymbol];
    if (ptr !== undefined) {
      const pointer = uniffiTypeKeyPackageStorageImplObjectFactory.pointer(this);
      uniffiTypeKeyPackageStorageImplObjectFactory.freePointer(pointer);
      uniffiTypeKeyPackageStorageImplObjectFactory.unbless(ptr);
      delete (this as any)[destructorGuardSymbol];
    }
  }

  static instanceOf(obj: any): obj is KeyPackageStorageImpl {
    return uniffiTypeKeyPackageStorageImplObjectFactory.isConcreteType(obj);
  }
}

const uniffiTypeKeyPackageStorageImplObjectFactory: UniffiObjectFactory<KeyPackageStorage> =
  (() => {
    /// <reference lib="es2021" />
    const registry =
      typeof FinalizationRegistry !== 'undefined'
        ? new FinalizationRegistry<UnsafeMutableRawPointer>(
            (heldValue: UnsafeMutableRawPointer) => {
              uniffiTypeKeyPackageStorageImplObjectFactory.freePointer(heldValue);
            }
          )
        : null;

    return {
      create(pointer: UnsafeMutableRawPointer): KeyPackageStorage {
        const instance = Object.create(KeyPackageStorageImpl.prototype);
        instance[pointerLiteralSymbol] = pointer;
        instance[destructorGuardSymbol] = this.bless(pointer);
        instance[uniffiTypeNameSymbol] = 'KeyPackageStorageImpl';
        return instance;
      },

      bless(p: UnsafeMutableRawPointer): UniffiRustArcPtr {
        const ptr = {
          p, // make sure this object doesn't get optimized away.
          markDestroyed: () => undefined,
        };
        if (registry) {
          registry.register(ptr, p, ptr);
        }
        return ptr;
      },

      unbless(ptr: UniffiRustArcPtr) {
        if (registry) {
          registry.unregister(ptr);
        }
      },

      pointer(obj: KeyPackageStorage): UnsafeMutableRawPointer {
        if ((obj as any)[destructorGuardSymbol] === undefined) {
          throw new UniffiInternalError.UnexpectedNullPointer();
        }
        return (obj as any)[pointerLiteralSymbol];
      },

      clonePointer(obj: KeyPackageStorage): UnsafeMutableRawPointer {
        const pointer = this.pointer(obj);
        return uniffiCaller.rustCall(
          /*caller:*/ (callStatus) =>
            nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_clone_keypackagestorage(
              pointer,
              callStatus
            ),
          /*liftString:*/ FfiConverterString.lift
        );
      },

      freePointer(pointer: UnsafeMutableRawPointer): void {
        uniffiCaller.rustCall(
          /*caller:*/ (callStatus) =>
            nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_free_keypackagestorage(pointer, callStatus),
          /*liftString:*/ FfiConverterString.lift
        );
      },

      isConcreteType(obj: any): obj is KeyPackageStorage {
        return obj[destructorGuardSymbol] && obj[uniffiTypeNameSymbol] === 'KeyPackageStorageImpl';
      },
    };
  })();
// FfiConverter for KeyPackageStorage
const FfiConverterTypeKeyPackageStorage = new FfiConverterObjectWithCallbacks(
  uniffiTypeKeyPackageStorageImplObjectFactory
);

// Add a vtavble for the callbacks that go in KeyPackageStorage.

// Put the implementation in a struct so we don't pollute the top-level namespace
const uniffiCallbackInterfaceKeyPackageStorage: { vtable: any; register: () => void } = {
  // Create the VTable using a series of closures.
  // ts automatically converts these into C callback functions.
  vtable: {
    insert: (uniffiHandle: bigint, id: Uint8Array, data: Uint8Array) => {
      const uniffiMakeCall = (): void => {
        const jsCallback = FfiConverterTypeKeyPackageStorage.lift(uniffiHandle);
        return jsCallback.insert(
          FfiConverterArrayBuffer.lift(id),
          FfiConverterArrayBuffer.lift(data)
        );
      };
      const uniffiResult = UniffiResult.ready<void>();
      const uniffiHandleSuccess = (obj: any) => {};
      const uniffiHandleError = (code: number, errBuf: UniffiByteArray) => {
        UniffiResult.writeError(uniffiResult, code, errBuf);
      };
      uniffiTraitInterfaceCallWithError(
        /*makeCall:*/ uniffiMakeCall,
        /*handleSuccess:*/ uniffiHandleSuccess,
        /*handleError:*/ uniffiHandleError,
        /*isErrorType:*/ Exception.instanceOf,
        /*lowerError:*/ FfiConverterTypeError.lower.bind(FfiConverterTypeError),
        /*lowerString:*/ FfiConverterString.lower
      );
      return uniffiResult;
    },
    get: (uniffiHandle: bigint, id: Uint8Array) => {
      const uniffiMakeCall = (): ArrayBuffer | undefined => {
        const jsCallback = FfiConverterTypeKeyPackageStorage.lift(uniffiHandle);
        return jsCallback.get(FfiConverterArrayBuffer.lift(id));
      };
      const uniffiResult = UniffiResult.ready<Uint8Array>();
      const uniffiHandleSuccess = (obj: any) => {
        UniffiResult.writeSuccess(uniffiResult, FfiConverterOptionalArrayBuffer.lower(obj));
      };
      const uniffiHandleError = (code: number, errBuf: UniffiByteArray) => {
        UniffiResult.writeError(uniffiResult, code, errBuf);
      };
      uniffiTraitInterfaceCallWithError(
        /*makeCall:*/ uniffiMakeCall,
        /*handleSuccess:*/ uniffiHandleSuccess,
        /*handleError:*/ uniffiHandleError,
        /*isErrorType:*/ Exception.instanceOf,
        /*lowerError:*/ FfiConverterTypeError.lower.bind(FfiConverterTypeError),
        /*lowerString:*/ FfiConverterString.lower
      );
      return uniffiResult;
    },
    delete: (uniffiHandle: bigint, id: Uint8Array) => {
      const uniffiMakeCall = (): void => {
        const jsCallback = FfiConverterTypeKeyPackageStorage.lift(uniffiHandle);
        return jsCallback.delete(FfiConverterArrayBuffer.lift(id));
      };
      const uniffiResult = UniffiResult.ready<void>();
      const uniffiHandleSuccess = (obj: any) => {};
      const uniffiHandleError = (code: number, errBuf: UniffiByteArray) => {
        UniffiResult.writeError(uniffiResult, code, errBuf);
      };
      uniffiTraitInterfaceCallWithError(
        /*makeCall:*/ uniffiMakeCall,
        /*handleSuccess:*/ uniffiHandleSuccess,
        /*handleError:*/ uniffiHandleError,
        /*isErrorType:*/ Exception.instanceOf,
        /*lowerError:*/ FfiConverterTypeError.lower.bind(FfiConverterTypeError),
        /*lowerString:*/ FfiConverterString.lower
      );
      return uniffiResult;
    },
    uniffiFree: (uniffiHandle: UniffiHandle): void => {
      // KeyPackageStorage: this will throw a stale handle error if the handle isn't found.
      FfiConverterTypeKeyPackageStorage.drop(uniffiHandle);
    },
  },
  register: () => {
    nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_init_callback_vtable_keypackagestorage(
      uniffiCallbackInterfaceKeyPackageStorage.vtable
    );
  },
};

/**
 * A [`mls_rs::MlsMessage`] wrapper.
 */
export interface MessageInterface {
  /**
   * Return the epoch of this message, if available.
   *
   * Commit and application messages carry the epoch in which they were created.
   * Welcome and KeyPackage messages do not have an epoch and will return `None`.
   */
  epoch(): /*u64*/ bigint | undefined;
  /**
   * If this is a key package, return its key package reference.
   */
  keyPackageReference(cipherSuite: CipherSuite): /*throws*/ ArrayBuffer | undefined;
  /**
   * If this is a welcome message, return key package references of all members who can
   * join using this message.
   */
  welcomeKeyPackageReferences(): Array<ArrayBuffer>;
}

/**
 * A [`mls_rs::MlsMessage`] wrapper.
 */
export class Message extends UniffiAbstractObject implements MessageInterface {
  readonly [uniffiTypeNameSymbol] = 'Message';
  readonly [destructorGuardSymbol]: UniffiRustArcPtr;
  readonly [pointerLiteralSymbol]: UnsafeMutableRawPointer;
  // No primary constructor declared for this class.
  private constructor(pointer: UnsafeMutableRawPointer) {
    super();
    this[pointerLiteralSymbol] = pointer;
    this[destructorGuardSymbol] = uniffiTypeMessageObjectFactory.bless(pointer);
  }

  /**
   * Return the epoch of this message, if available.
   *
   * Commit and application messages carry the epoch in which they were created.
   * Welcome and KeyPackage messages do not have an epoch and will return `None`.
   */
  public epoch(): /*u64*/ bigint | undefined {
    return FfiConverterOptionalUInt64.lift(
      uniffiCaller.rustCall(
        /*caller:*/ (callStatus) => {
          return nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_method_message_epoch(
            uniffiTypeMessageObjectFactory.clonePointer(this),
            callStatus
          );
        },
        /*liftString:*/ FfiConverterString.lift
      )
    );
  }

  /**
   * If this is a key package, return its key package reference.
   */
  public keyPackageReference(cipherSuite: CipherSuite): ArrayBuffer | undefined /*throws*/ {
    return FfiConverterOptionalArrayBuffer.lift(
      uniffiCaller.rustCallWithError(
        /*liftError:*/ FfiConverterTypeError.lift.bind(FfiConverterTypeError),
        /*caller:*/ (callStatus) => {
          return nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_method_message_key_package_reference(
            uniffiTypeMessageObjectFactory.clonePointer(this),
            FfiConverterTypeCipherSuite.lower(cipherSuite),
            callStatus
          );
        },
        /*liftString:*/ FfiConverterString.lift
      )
    );
  }

  /**
   * If this is a welcome message, return key package references of all members who can
   * join using this message.
   */
  public welcomeKeyPackageReferences(): Array<ArrayBuffer> {
    return FfiConverterArrayArrayBuffer.lift(
      uniffiCaller.rustCall(
        /*caller:*/ (callStatus) => {
          return nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_method_message_welcome_key_package_references(
            uniffiTypeMessageObjectFactory.clonePointer(this),
            callStatus
          );
        },
        /*liftString:*/ FfiConverterString.lift
      )
    );
  }

  /**
   * {@inheritDoc uniffi-bindgen-react-native#UniffiAbstractObject.uniffiDestroy}
   */
  uniffiDestroy(): void {
    const ptr = (this as any)[destructorGuardSymbol];
    if (ptr !== undefined) {
      const pointer = uniffiTypeMessageObjectFactory.pointer(this);
      uniffiTypeMessageObjectFactory.freePointer(pointer);
      uniffiTypeMessageObjectFactory.unbless(ptr);
      delete (this as any)[destructorGuardSymbol];
    }
  }

  static instanceOf(obj: any): obj is Message {
    return uniffiTypeMessageObjectFactory.isConcreteType(obj);
  }
}

const uniffiTypeMessageObjectFactory: UniffiObjectFactory<MessageInterface> = (() => {
  /// <reference lib="es2021" />
  const registry =
    typeof FinalizationRegistry !== 'undefined'
      ? new FinalizationRegistry<UnsafeMutableRawPointer>((heldValue: UnsafeMutableRawPointer) => {
          uniffiTypeMessageObjectFactory.freePointer(heldValue);
        })
      : null;

  return {
    create(pointer: UnsafeMutableRawPointer): MessageInterface {
      const instance = Object.create(Message.prototype);
      instance[pointerLiteralSymbol] = pointer;
      instance[destructorGuardSymbol] = this.bless(pointer);
      instance[uniffiTypeNameSymbol] = 'Message';
      return instance;
    },

    bless(p: UnsafeMutableRawPointer): UniffiRustArcPtr {
      const ptr = {
        p, // make sure this object doesn't get optimized away.
        markDestroyed: () => undefined,
      };
      if (registry) {
        registry.register(ptr, p, ptr);
      }
      return ptr;
    },

    unbless(ptr: UniffiRustArcPtr) {
      if (registry) {
        registry.unregister(ptr);
      }
    },

    pointer(obj: MessageInterface): UnsafeMutableRawPointer {
      if ((obj as any)[destructorGuardSymbol] === undefined) {
        throw new UniffiInternalError.UnexpectedNullPointer();
      }
      return (obj as any)[pointerLiteralSymbol];
    },

    clonePointer(obj: MessageInterface): UnsafeMutableRawPointer {
      const pointer = this.pointer(obj);
      return uniffiCaller.rustCall(
        /*caller:*/ (callStatus) =>
          nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_clone_message(pointer, callStatus),
        /*liftString:*/ FfiConverterString.lift
      );
    },

    freePointer(pointer: UnsafeMutableRawPointer): void {
      uniffiCaller.rustCall(
        /*caller:*/ (callStatus) =>
          nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_free_message(pointer, callStatus),
        /*liftString:*/ FfiConverterString.lift
      );
    },

    isConcreteType(obj: any): obj is MessageInterface {
      return obj[destructorGuardSymbol] && obj[uniffiTypeNameSymbol] === 'Message';
    },
  };
})();
// FfiConverter for MessageInterface
const FfiConverterTypeMessage = new FfiConverterObject(uniffiTypeMessageObjectFactory);

export interface ProposalInterface {}

export class Proposal extends UniffiAbstractObject implements ProposalInterface {
  readonly [uniffiTypeNameSymbol] = 'Proposal';
  readonly [destructorGuardSymbol]: UniffiRustArcPtr;
  readonly [pointerLiteralSymbol]: UnsafeMutableRawPointer;
  // No primary constructor declared for this class.
  private constructor(pointer: UnsafeMutableRawPointer) {
    super();
    this[pointerLiteralSymbol] = pointer;
    this[destructorGuardSymbol] = uniffiTypeProposalObjectFactory.bless(pointer);
  }

  /**
   * {@inheritDoc uniffi-bindgen-react-native#UniffiAbstractObject.uniffiDestroy}
   */
  uniffiDestroy(): void {
    const ptr = (this as any)[destructorGuardSymbol];
    if (ptr !== undefined) {
      const pointer = uniffiTypeProposalObjectFactory.pointer(this);
      uniffiTypeProposalObjectFactory.freePointer(pointer);
      uniffiTypeProposalObjectFactory.unbless(ptr);
      delete (this as any)[destructorGuardSymbol];
    }
  }

  static instanceOf(obj: any): obj is Proposal {
    return uniffiTypeProposalObjectFactory.isConcreteType(obj);
  }
}

const uniffiTypeProposalObjectFactory: UniffiObjectFactory<ProposalInterface> = (() => {
  /// <reference lib="es2021" />
  const registry =
    typeof FinalizationRegistry !== 'undefined'
      ? new FinalizationRegistry<UnsafeMutableRawPointer>((heldValue: UnsafeMutableRawPointer) => {
          uniffiTypeProposalObjectFactory.freePointer(heldValue);
        })
      : null;

  return {
    create(pointer: UnsafeMutableRawPointer): ProposalInterface {
      const instance = Object.create(Proposal.prototype);
      instance[pointerLiteralSymbol] = pointer;
      instance[destructorGuardSymbol] = this.bless(pointer);
      instance[uniffiTypeNameSymbol] = 'Proposal';
      return instance;
    },

    bless(p: UnsafeMutableRawPointer): UniffiRustArcPtr {
      const ptr = {
        p, // make sure this object doesn't get optimized away.
        markDestroyed: () => undefined,
      };
      if (registry) {
        registry.register(ptr, p, ptr);
      }
      return ptr;
    },

    unbless(ptr: UniffiRustArcPtr) {
      if (registry) {
        registry.unregister(ptr);
      }
    },

    pointer(obj: ProposalInterface): UnsafeMutableRawPointer {
      if ((obj as any)[destructorGuardSymbol] === undefined) {
        throw new UniffiInternalError.UnexpectedNullPointer();
      }
      return (obj as any)[pointerLiteralSymbol];
    },

    clonePointer(obj: ProposalInterface): UnsafeMutableRawPointer {
      const pointer = this.pointer(obj);
      return uniffiCaller.rustCall(
        /*caller:*/ (callStatus) =>
          nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_clone_proposal(pointer, callStatus),
        /*liftString:*/ FfiConverterString.lift
      );
    },

    freePointer(pointer: UnsafeMutableRawPointer): void {
      uniffiCaller.rustCall(
        /*caller:*/ (callStatus) =>
          nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_free_proposal(pointer, callStatus),
        /*liftString:*/ FfiConverterString.lift
      );
    },

    isConcreteType(obj: any): obj is ProposalInterface {
      return obj[destructorGuardSymbol] && obj[uniffiTypeNameSymbol] === 'Proposal';
    },
  };
})();
// FfiConverter for ProposalInterface
const FfiConverterTypeProposal = new FfiConverterObject(uniffiTypeProposalObjectFactory);

export interface SigningIdentityInterface {}

export class SigningIdentity extends UniffiAbstractObject implements SigningIdentityInterface {
  readonly [uniffiTypeNameSymbol] = 'SigningIdentity';
  readonly [destructorGuardSymbol]: UniffiRustArcPtr;
  readonly [pointerLiteralSymbol]: UnsafeMutableRawPointer;
  // No primary constructor declared for this class.
  private constructor(pointer: UnsafeMutableRawPointer) {
    super();
    this[pointerLiteralSymbol] = pointer;
    this[destructorGuardSymbol] = uniffiTypeSigningIdentityObjectFactory.bless(pointer);
  }

  /**
   * Calls into the `==` method of `SigningIdentityInterface` (the native Rust peer).
   *
   * Returns `true` if and only if the two instance of `SigningIdentityInterface` are
   * equivalent on the Rust side.
   *
   * Generated by deriving the `Eq` trait in Rust.
   */
  equals(other: SigningIdentity): boolean {
    return FfiConverterBool.lift(
      uniffiCaller.rustCall(
        /*caller:*/ (callStatus) => {
          return nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_method_signingidentity_uniffi_trait_eq_eq(
            uniffiTypeSigningIdentityObjectFactory.clonePointer(this),
            FfiConverterTypeSigningIdentity.lower(other),
            callStatus
          );
        },
        /*liftString:*/ FfiConverterString.lift
      )
    );
  }

  /**
   * {@inheritDoc uniffi-bindgen-react-native#UniffiAbstractObject.uniffiDestroy}
   */
  uniffiDestroy(): void {
    const ptr = (this as any)[destructorGuardSymbol];
    if (ptr !== undefined) {
      const pointer = uniffiTypeSigningIdentityObjectFactory.pointer(this);
      uniffiTypeSigningIdentityObjectFactory.freePointer(pointer);
      uniffiTypeSigningIdentityObjectFactory.unbless(ptr);
      delete (this as any)[destructorGuardSymbol];
    }
  }

  static instanceOf(obj: any): obj is SigningIdentity {
    return uniffiTypeSigningIdentityObjectFactory.isConcreteType(obj);
  }
}

const uniffiTypeSigningIdentityObjectFactory: UniffiObjectFactory<SigningIdentityInterface> =
  (() => {
    /// <reference lib="es2021" />
    const registry =
      typeof FinalizationRegistry !== 'undefined'
        ? new FinalizationRegistry<UnsafeMutableRawPointer>(
            (heldValue: UnsafeMutableRawPointer) => {
              uniffiTypeSigningIdentityObjectFactory.freePointer(heldValue);
            }
          )
        : null;

    return {
      create(pointer: UnsafeMutableRawPointer): SigningIdentityInterface {
        const instance = Object.create(SigningIdentity.prototype);
        instance[pointerLiteralSymbol] = pointer;
        instance[destructorGuardSymbol] = this.bless(pointer);
        instance[uniffiTypeNameSymbol] = 'SigningIdentity';
        return instance;
      },

      bless(p: UnsafeMutableRawPointer): UniffiRustArcPtr {
        const ptr = {
          p, // make sure this object doesn't get optimized away.
          markDestroyed: () => undefined,
        };
        if (registry) {
          registry.register(ptr, p, ptr);
        }
        return ptr;
      },

      unbless(ptr: UniffiRustArcPtr) {
        if (registry) {
          registry.unregister(ptr);
        }
      },

      pointer(obj: SigningIdentityInterface): UnsafeMutableRawPointer {
        if ((obj as any)[destructorGuardSymbol] === undefined) {
          throw new UniffiInternalError.UnexpectedNullPointer();
        }
        return (obj as any)[pointerLiteralSymbol];
      },

      clonePointer(obj: SigningIdentityInterface): UnsafeMutableRawPointer {
        const pointer = this.pointer(obj);
        return uniffiCaller.rustCall(
          /*caller:*/ (callStatus) =>
            nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_clone_signingidentity(pointer, callStatus),
          /*liftString:*/ FfiConverterString.lift
        );
      },

      freePointer(pointer: UnsafeMutableRawPointer): void {
        uniffiCaller.rustCall(
          /*caller:*/ (callStatus) =>
            nativeModule().ubrn_uniffi_mls_rs_uniffi_fn_free_signingidentity(pointer, callStatus),
          /*liftString:*/ FfiConverterString.lift
        );
      },

      isConcreteType(obj: any): obj is SigningIdentityInterface {
        return obj[destructorGuardSymbol] && obj[uniffiTypeNameSymbol] === 'SigningIdentity';
      },
    };
  })();
// FfiConverter for SigningIdentityInterface
const FfiConverterTypeSigningIdentity = new FfiConverterObject(
  uniffiTypeSigningIdentityObjectFactory
);

// FfiConverter for ArrayBuffer | undefined
const FfiConverterOptionalArrayBuffer = new FfiConverterOptional(FfiConverterArrayBuffer);

// FfiConverter for RatchetTree | undefined
const FfiConverterOptionalTypeRatchetTree = new FfiConverterOptional(FfiConverterTypeRatchetTree);

// FfiConverter for /*u64*/bigint | undefined
const FfiConverterOptionalUInt64 = new FfiConverterOptional(FfiConverterUInt64);

// FfiConverter for Array<ArrayBuffer>
const FfiConverterArrayArrayBuffer = new FfiConverterArray(FfiConverterArrayBuffer);

// FfiConverter for Array<EpochRecord>
const FfiConverterArrayTypeEpochRecord = new FfiConverterArray(FfiConverterTypeEpochRecord);

// FfiConverter for Array<GroupMemberInfo>
const FfiConverterArrayTypeGroupMemberInfo = new FfiConverterArray(FfiConverterTypeGroupMemberInfo);

// FfiConverter for MessageInterface | undefined
const FfiConverterOptionalTypeMessage = new FfiConverterOptional(FfiConverterTypeMessage);

// FfiConverter for Array<MessageInterface>
const FfiConverterArrayTypeMessage = new FfiConverterArray(FfiConverterTypeMessage);

// FfiConverter for Array<ProposalInterface>
const FfiConverterArrayTypeProposal = new FfiConverterArray(FfiConverterTypeProposal);

// FfiConverter for Array<SigningIdentityInterface>
const FfiConverterArrayTypeSigningIdentity = new FfiConverterArray(FfiConverterTypeSigningIdentity);

/**
 * This should be called before anything else.
 *
 * It is likely that this is being done for you by the library's `index.ts`.
 *
 * It checks versions of uniffi between when the Rust scaffolding was generated
 * and when the bindings were generated.
 *
 * It also initializes the machinery to enable Rust to talk back to Javascript.
 */
function uniffiEnsureInitialized() {
  // Get the bindings contract version from our ComponentInterface
  const bindingsContractVersion = 29;
  // Get the scaffolding contract version by calling the into the dylib
  const scaffoldingContractVersion =
    nativeModule().ubrn_ffi_mls_rs_uniffi_uniffi_contract_version();
  if (bindingsContractVersion !== scaffoldingContractVersion) {
    throw new UniffiInternalError.ContractVersionMismatch(
      scaffoldingContractVersion,
      bindingsContractVersion
    );
  }
  if (nativeModule().ubrn_uniffi_mls_rs_uniffi_checksum_func_client_config_default() !== 59081) {
    throw new UniffiInternalError.ApiChecksumMismatch(
      'uniffi_mls_rs_uniffi_checksum_func_client_config_default'
    );
  }
  if (
    nativeModule().ubrn_uniffi_mls_rs_uniffi_checksum_func_generate_signature_keypair() !== 43077
  ) {
    throw new UniffiInternalError.ApiChecksumMismatch(
      'uniffi_mls_rs_uniffi_checksum_func_generate_signature_keypair'
    );
  }
  if (nativeModule().ubrn_uniffi_mls_rs_uniffi_checksum_func_message_from_bytes() !== 24135) {
    throw new UniffiInternalError.ApiChecksumMismatch(
      'uniffi_mls_rs_uniffi_checksum_func_message_from_bytes'
    );
  }
  if (nativeModule().ubrn_uniffi_mls_rs_uniffi_checksum_func_message_to_bytes() !== 63373) {
    throw new UniffiInternalError.ApiChecksumMismatch(
      'uniffi_mls_rs_uniffi_checksum_func_message_to_bytes'
    );
  }
  if (nativeModule().ubrn_uniffi_mls_rs_uniffi_checksum_method_client_create_group() !== 51396) {
    throw new UniffiInternalError.ApiChecksumMismatch(
      'uniffi_mls_rs_uniffi_checksum_method_client_create_group'
    );
  }
  if (
    nativeModule().ubrn_uniffi_mls_rs_uniffi_checksum_method_client_generate_key_package_message() !==
    59803
  ) {
    throw new UniffiInternalError.ApiChecksumMismatch(
      'uniffi_mls_rs_uniffi_checksum_method_client_generate_key_package_message'
    );
  }
  if (nativeModule().ubrn_uniffi_mls_rs_uniffi_checksum_method_client_join_group() !== 25011) {
    throw new UniffiInternalError.ApiChecksumMismatch(
      'uniffi_mls_rs_uniffi_checksum_method_client_join_group'
    );
  }
  if (nativeModule().ubrn_uniffi_mls_rs_uniffi_checksum_method_client_load_group() !== 56228) {
    throw new UniffiInternalError.ApiChecksumMismatch(
      'uniffi_mls_rs_uniffi_checksum_method_client_load_group'
    );
  }
  if (
    nativeModule().ubrn_uniffi_mls_rs_uniffi_checksum_method_client_signing_identity() !== 45906
  ) {
    throw new UniffiInternalError.ApiChecksumMismatch(
      'uniffi_mls_rs_uniffi_checksum_method_client_signing_identity'
    );
  }
  if (
    nativeModule().ubrn_uniffi_mls_rs_uniffi_checksum_method_commitbuilder_add_member() !== 20602
  ) {
    throw new UniffiInternalError.ApiChecksumMismatch(
      'uniffi_mls_rs_uniffi_checksum_method_commitbuilder_add_member'
    );
  }
  if (
    nativeModule().ubrn_uniffi_mls_rs_uniffi_checksum_method_commitbuilder_add_members() !== 63993
  ) {
    throw new UniffiInternalError.ApiChecksumMismatch(
      'uniffi_mls_rs_uniffi_checksum_method_commitbuilder_add_members'
    );
  }
  if (nativeModule().ubrn_uniffi_mls_rs_uniffi_checksum_method_commitbuilder_build() !== 28486) {
    throw new UniffiInternalError.ApiChecksumMismatch(
      'uniffi_mls_rs_uniffi_checksum_method_commitbuilder_build'
    );
  }
  if (
    nativeModule().ubrn_uniffi_mls_rs_uniffi_checksum_method_commitbuilder_remove_member() !== 56537
  ) {
    throw new UniffiInternalError.ApiChecksumMismatch(
      'uniffi_mls_rs_uniffi_checksum_method_commitbuilder_remove_member'
    );
  }
  if (
    nativeModule().ubrn_uniffi_mls_rs_uniffi_checksum_method_commitbuilder_remove_members() !==
    46140
  ) {
    throw new UniffiInternalError.ApiChecksumMismatch(
      'uniffi_mls_rs_uniffi_checksum_method_commitbuilder_remove_members'
    );
  }
  if (nativeModule().ubrn_uniffi_mls_rs_uniffi_checksum_method_group_add_members() !== 25086) {
    throw new UniffiInternalError.ApiChecksumMismatch(
      'uniffi_mls_rs_uniffi_checksum_method_group_add_members'
    );
  }
  if (
    nativeModule().ubrn_uniffi_mls_rs_uniffi_checksum_method_group_clear_pending_commit() !== 29621
  ) {
    throw new UniffiInternalError.ApiChecksumMismatch(
      'uniffi_mls_rs_uniffi_checksum_method_group_clear_pending_commit'
    );
  }
  if (nativeModule().ubrn_uniffi_mls_rs_uniffi_checksum_method_group_commit() !== 61236) {
    throw new UniffiInternalError.ApiChecksumMismatch(
      'uniffi_mls_rs_uniffi_checksum_method_group_commit'
    );
  }
  if (nativeModule().ubrn_uniffi_mls_rs_uniffi_checksum_method_group_commit_builder() !== 42195) {
    throw new UniffiInternalError.ApiChecksumMismatch(
      'uniffi_mls_rs_uniffi_checksum_method_group_commit_builder'
    );
  }
  if (nativeModule().ubrn_uniffi_mls_rs_uniffi_checksum_method_group_current_epoch() !== 20566) {
    throw new UniffiInternalError.ApiChecksumMismatch(
      'uniffi_mls_rs_uniffi_checksum_method_group_current_epoch'
    );
  }
  if (
    nativeModule().ubrn_uniffi_mls_rs_uniffi_checksum_method_group_encrypt_application_message() !==
    52772
  ) {
    throw new UniffiInternalError.ApiChecksumMismatch(
      'uniffi_mls_rs_uniffi_checksum_method_group_encrypt_application_message'
    );
  }
  if (nativeModule().ubrn_uniffi_mls_rs_uniffi_checksum_method_group_export_tree() !== 57366) {
    throw new UniffiInternalError.ApiChecksumMismatch(
      'uniffi_mls_rs_uniffi_checksum_method_group_export_tree'
    );
  }
  if (nativeModule().ubrn_uniffi_mls_rs_uniffi_checksum_method_group_group_id() !== 55077) {
    throw new UniffiInternalError.ApiChecksumMismatch(
      'uniffi_mls_rs_uniffi_checksum_method_group_group_id'
    );
  }
  if (nativeModule().ubrn_uniffi_mls_rs_uniffi_checksum_method_group_members() !== 14212) {
    throw new UniffiInternalError.ApiChecksumMismatch(
      'uniffi_mls_rs_uniffi_checksum_method_group_members'
    );
  }
  if (
    nativeModule().ubrn_uniffi_mls_rs_uniffi_checksum_method_group_process_incoming_message() !==
    54676
  ) {
    throw new UniffiInternalError.ApiChecksumMismatch(
      'uniffi_mls_rs_uniffi_checksum_method_group_process_incoming_message'
    );
  }
  if (
    nativeModule().ubrn_uniffi_mls_rs_uniffi_checksum_method_group_propose_add_members() !== 53017
  ) {
    throw new UniffiInternalError.ApiChecksumMismatch(
      'uniffi_mls_rs_uniffi_checksum_method_group_propose_add_members'
    );
  }
  if (
    nativeModule().ubrn_uniffi_mls_rs_uniffi_checksum_method_group_propose_remove_members() !==
    64305
  ) {
    throw new UniffiInternalError.ApiChecksumMismatch(
      'uniffi_mls_rs_uniffi_checksum_method_group_propose_remove_members'
    );
  }
  if (nativeModule().ubrn_uniffi_mls_rs_uniffi_checksum_method_group_remove_members() !== 44981) {
    throw new UniffiInternalError.ApiChecksumMismatch(
      'uniffi_mls_rs_uniffi_checksum_method_group_remove_members'
    );
  }
  if (nativeModule().ubrn_uniffi_mls_rs_uniffi_checksum_method_group_write_to_storage() !== 36882) {
    throw new UniffiInternalError.ApiChecksumMismatch(
      'uniffi_mls_rs_uniffi_checksum_method_group_write_to_storage'
    );
  }
  if (
    nativeModule().ubrn_uniffi_mls_rs_uniffi_checksum_method_groupstatestorage_state() !== 29291
  ) {
    throw new UniffiInternalError.ApiChecksumMismatch(
      'uniffi_mls_rs_uniffi_checksum_method_groupstatestorage_state'
    );
  }
  if (
    nativeModule().ubrn_uniffi_mls_rs_uniffi_checksum_method_groupstatestorage_epoch() !== 34987
  ) {
    throw new UniffiInternalError.ApiChecksumMismatch(
      'uniffi_mls_rs_uniffi_checksum_method_groupstatestorage_epoch'
    );
  }
  if (
    nativeModule().ubrn_uniffi_mls_rs_uniffi_checksum_method_groupstatestorage_write() !== 39480
  ) {
    throw new UniffiInternalError.ApiChecksumMismatch(
      'uniffi_mls_rs_uniffi_checksum_method_groupstatestorage_write'
    );
  }
  if (
    nativeModule().ubrn_uniffi_mls_rs_uniffi_checksum_method_groupstatestorage_max_epoch_id() !==
    1285
  ) {
    throw new UniffiInternalError.ApiChecksumMismatch(
      'uniffi_mls_rs_uniffi_checksum_method_groupstatestorage_max_epoch_id'
    );
  }
  if (
    nativeModule().ubrn_uniffi_mls_rs_uniffi_checksum_method_keypackagestorage_insert() !== 19467
  ) {
    throw new UniffiInternalError.ApiChecksumMismatch(
      'uniffi_mls_rs_uniffi_checksum_method_keypackagestorage_insert'
    );
  }
  if (nativeModule().ubrn_uniffi_mls_rs_uniffi_checksum_method_keypackagestorage_get() !== 11921) {
    throw new UniffiInternalError.ApiChecksumMismatch(
      'uniffi_mls_rs_uniffi_checksum_method_keypackagestorage_get'
    );
  }
  if (
    nativeModule().ubrn_uniffi_mls_rs_uniffi_checksum_method_keypackagestorage_delete() !== 44821
  ) {
    throw new UniffiInternalError.ApiChecksumMismatch(
      'uniffi_mls_rs_uniffi_checksum_method_keypackagestorage_delete'
    );
  }
  if (nativeModule().ubrn_uniffi_mls_rs_uniffi_checksum_method_message_epoch() !== 55011) {
    throw new UniffiInternalError.ApiChecksumMismatch(
      'uniffi_mls_rs_uniffi_checksum_method_message_epoch'
    );
  }
  if (
    nativeModule().ubrn_uniffi_mls_rs_uniffi_checksum_method_message_key_package_reference() !==
    55541
  ) {
    throw new UniffiInternalError.ApiChecksumMismatch(
      'uniffi_mls_rs_uniffi_checksum_method_message_key_package_reference'
    );
  }
  if (
    nativeModule().ubrn_uniffi_mls_rs_uniffi_checksum_method_message_welcome_key_package_references() !==
    40305
  ) {
    throw new UniffiInternalError.ApiChecksumMismatch(
      'uniffi_mls_rs_uniffi_checksum_method_message_welcome_key_package_references'
    );
  }
  if (nativeModule().ubrn_uniffi_mls_rs_uniffi_checksum_constructor_client_new() !== 58071) {
    throw new UniffiInternalError.ApiChecksumMismatch(
      'uniffi_mls_rs_uniffi_checksum_constructor_client_new'
    );
  }

  uniffiCallbackInterfaceGroupStateStorage.register();
  uniffiCallbackInterfaceKeyPackageStorage.register();
}

export default Object.freeze({
  initialize: uniffiEnsureInitialized,
  converters: {
    FfiConverterTypeCipherSuite,
    FfiConverterTypeClient,
    FfiConverterTypeClientConfig,
    FfiConverterTypeCommitBuilder,
    FfiConverterTypeCommitEffect,
    FfiConverterTypeCommitOutput,
    FfiConverterTypeEpochRecord,
    FfiConverterTypeError,
    FfiConverterTypeExtension,
    FfiConverterTypeExtensionList,
    FfiConverterTypeGroup,
    FfiConverterTypeGroupMemberInfo,
    FfiConverterTypeGroupStateStorage,
    FfiConverterTypeJoinInfo,
    FfiConverterTypeKeyPackageStorage,
    FfiConverterTypeMessage,
    FfiConverterTypeProposal,
    FfiConverterTypeProtocolVersion,
    FfiConverterTypeRatchetTree,
    FfiConverterTypeReceivedMessage,
    FfiConverterTypeSignatureKeypair,
    FfiConverterTypeSignaturePublicKey,
    FfiConverterTypeSignatureSecretKey,
    FfiConverterTypeSigningIdentity,
  },
});
